! function() {
    function isMoblieBrowser() {
        var e = !1;
        try {
            ! function(o) {
                (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(o) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(o.substr(0, 4))) && (e = !0)
            }(navigator.userAgent || navigator.vendor || window.opera)
        } catch (e) {
            console.log(e)
        }
        return e
    }

    function floatToString(e, o) {
        var t = e.toFixed(o).toString();
        return t.match(/^\.\d+/) ? "0" + t : t
    }

    function attributeToString(e) {
        return "string" != typeof e && "undefined" === (e += "") && (e = ""), jQuery.trim(e)
    }

    function loadProductFromCart(e) {
        e.ajax({
            dataType: "json",
            url: "/cart.js",
            success: function(o) {
                var t = [];
                e.each(o.items, function(e, o) {
                    t.push(o.id)
                }), list_cart_variants = t
            }
        })
    }

    function scaqvImageZoom(e, o, t, i) {
        "function" != typeof Object.create && (Object.create = function(e) {
                function o() {}
                return o.prototype = e, new o
            }),
            function(e, o, t, i) {
                var n = {
                    init: function(o, t) {
                        var i = this;
                        i.elem = t, i.$elem = e(t), i.imageSrc = i.$elem.data("zoom-image") ? i.$elem.data("zoom-image") : i.$elem.attr("src"), i.options = e.extend({}, e.fn.elevateZoom.options, o), i.options.tint && (i.options.lensColour = "none", i.options.lensOpacity = "1"), "inner" == i.options.zoomType && (i.options.showLens = !1), i.$elem.parent().removeAttr("title").removeAttr("alt"), i.zoomImage = i.imageSrc, i.refresh(1), e("#" + i.options.gallery + " a").click(function(o) {
                            return i.options.galleryActiveClass && (e("#" + i.options.gallery + " a").removeClass(i.options.galleryActiveClass), e(this).addClass(i.options.galleryActiveClass)), o.preventDefault(), e(this).data("zoom-image") ? i.zoomImagePre = e(this).data("zoom-image") : i.zoomImagePre = e(this).data("image"), i.swaptheimage(e(this).data("image"), i.zoomImagePre), !1
                        })
                    },
                    refresh: function(e) {
                        var o = this;
                        setTimeout(function() {
                            o.fetch(o.imageSrc)
                        }, e || o.options.refresh)
                    },
                    fetch: function(e) {
                        var o = this,
                            t = new Image;
                        t.onload = function() {
                            o.largeWidth = t.width, o.largeHeight = t.height, o.startZoom(), o.currentImage = o.imageSrc, o.options.onZoomedImageLoaded(o.$elem)
                        }, t.src = e
                    },
                    startZoom: function() {
                        var o = this;
                        if (o.nzWidth = o.$elem.width(), o.nzHeight = o.$elem.height(), o.isWindowActive = !1, o.isLensActive = !1, o.isTintActive = !1, o.overWindow = !1, o.options.imageCrossfade && (o.zoomWrap = o.$elem.wrap('<div style="height:' + o.nzHeight + "px;width:" + o.nzWidth + 'px;" class="zoomWrapper" />')), o.zoomLock = 1, o.scrollingLock = !1, o.changeBgSize = !1, o.currentZoomLevel = o.options.zoomLevel, o.nzOffset = o.$elem.offset(), o.widthRatio = o.largeWidth / o.currentZoomLevel / o.nzWidth, o.heightRatio = o.largeHeight / o.currentZoomLevel / o.nzHeight, "window" == o.options.zoomType && (o.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " + String(o.options.zoomWindowBgColour) + ";width: " + String(o.options.zoomWindowWidth) + "px;height: " + String(o.options.zoomWindowHeight) + "px;float: left;background-size: " + o.largeWidth / o.currentZoomLevel + "px " + o.largeHeight / o.currentZoomLevel + "px;display: none;z-index:100;border: " + String(o.options.borderSize) + "px solid " + o.options.borderColour + ";background-repeat: no-repeat;position: absolute;"), "inner" == o.options.zoomType) {
                            var t = o.$elem.css("border-left-width");
                            o.zoomWindowStyle = "overflow: hidden;margin-left: " + String(t) + ";margin-top: " + String(t) + ";background-position: 0px 0px;width: " + String(o.nzWidth) + "px;height: " + String(o.nzHeight) + "px;float: left;display: none;cursor:" + o.options.cursor + ";px solid " + o.options.borderColour + ";background-repeat: no-repeat;position: absolute;"
                        }
                        "window" == o.options.zoomType && (o.nzHeight < o.options.zoomWindowWidth / o.widthRatio ? lensHeight = o.nzHeight : lensHeight = String(o.options.zoomWindowHeight / o.heightRatio), o.largeWidth < o.options.zoomWindowWidth ? lensWidth = o.nzWidth : lensWidth = o.options.zoomWindowWidth / o.widthRatio, o.lensStyle = "background-position: 0px 0px;width: " + String(o.options.zoomWindowWidth / o.widthRatio) + "px;height: " + String(o.options.zoomWindowHeight / o.heightRatio) + "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" + o.options.lensOpacity + ";filter: alpha(opacity = " + 100 * o.options.lensOpacity + "); zoom:1;width:" + lensWidth + "px;height:" + lensHeight + "px;background-color:" + o.options.lensColour + ";cursor:" + o.options.cursor + ";border: " + o.options.lensBorderSize + "px solid " + o.options.lensBorderColour + ";background-repeat: no-repeat;position: absolute;"), o.tintStyle = "display: block;position: absolute;background-color: " + o.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + o.nzWidth + "px;height: " + o.nzHeight + "px;", o.lensRound = "", "lens" == o.options.zoomType && (o.lensStyle = "background-position: 0px 0px;float: left;display: none;border: " + String(o.options.borderSize) + "px solid " + o.options.borderColour + ";width:" + String(o.options.lensSize) + "px;height:" + String(o.options.lensSize) + "px;background-repeat: no-repeat;position: absolute;"), "round" == o.options.lensShape && (o.lensRound = "border-top-left-radius: " + String(o.options.lensSize / 2 + o.options.borderSize) + "px;border-top-right-radius: " + String(o.options.lensSize / 2 + o.options.borderSize) + "px;border-bottom-left-radius: " + String(o.options.lensSize / 2 + o.options.borderSize) + "px;border-bottom-right-radius: " + String(o.options.lensSize / 2 + o.options.borderSize) + "px;"), o.zoomContainer = e('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' + o.nzOffset.left + "px;top:" + o.nzOffset.top + "px;height:" + o.nzHeight + "px;width:" + o.nzWidth + 'px;"></div>'), e("body").append(o.zoomContainer), o.options.containLensZoom && "lens" == o.options.zoomType && o.zoomContainer.css("overflow", "hidden"), "inner" != o.options.zoomType && (o.zoomLens = e("<div class='zoomLens' style='" + o.lensStyle + o.lensRound + "'>&nbsp;</div>").appendTo(o.zoomContainer).click(function() {
                            o.$elem.trigger("click")
                        }), o.options.tint && (o.tintContainer = e("<div/>").addClass("tintContainer"), o.zoomTint = e("<div class='zoomTint' style='" + o.tintStyle + "'></div>"), o.zoomLens.wrap(o.tintContainer), o.zoomTintcss = o.zoomLens.after(o.zoomTint), o.zoomTintImage = e('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + o.nzWidth + "px; height: " + o.nzHeight + 'px;" src="' + o.imageSrc + '">').appendTo(o.zoomLens).click(function() {
                            o.$elem.trigger("click")
                        }))), isNaN(o.options.zoomWindowPosition) ? o.zoomWindow = e("<div style='z-index:999;left:" + o.windowOffsetLeft + "px;top:" + o.windowOffsetTop + "px;" + o.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function() {
                            o.$elem.trigger("click")
                        }) : o.zoomWindow = e("<div style='z-index:999;left:" + o.windowOffsetLeft + "px;top:" + o.windowOffsetTop + "px;" + o.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(o.zoomContainer).click(function() {
                            o.$elem.trigger("click")
                        }), o.zoomWindowContainer = e("<div/>").addClass("zoomWindowContainer").css("width", o.options.zoomWindowWidth), o.zoomWindow.wrap(o.zoomWindowContainer), "lens" == o.options.zoomType && o.zoomLens.css({
                            backgroundImage: "url('" + o.imageSrc + "')"
                        }), "window" == o.options.zoomType && o.zoomWindow.css({
                            backgroundImage: "url('" + o.imageSrc + "')"
                        }), "inner" == o.options.zoomType && o.zoomWindow.css({
                            backgroundImage: "url('" + o.imageSrc + "')"
                        }), o.$elem.bind("touchmove", function(e) {
                            e.preventDefault();
                            var t = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                            o.setPosition(t)
                        }), o.zoomContainer.bind("touchmove", function(e) {
                            "inner" == o.options.zoomType && o.showHideWindow("show"), e.preventDefault();
                            var t = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                            o.setPosition(t)
                        }), o.zoomContainer.bind("touchend", function(e) {
                            o.showHideWindow("hide"), o.options.showLens && o.showHideLens("hide"), o.options.tint && "inner" != o.options.zoomType && o.showHideTint("hide")
                        }), o.$elem.bind("touchend", function(e) {
                            o.showHideWindow("hide"), o.options.showLens && o.showHideLens("hide"), o.options.tint && "inner" != o.options.zoomType && o.showHideTint("hide")
                        }), o.options.showLens && (o.zoomLens.bind("touchmove", function(e) {
                            e.preventDefault();
                            var t = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                            o.setPosition(t)
                        }), o.zoomLens.bind("touchend", function(e) {
                            o.showHideWindow("hide"), o.options.showLens && o.showHideLens("hide"), o.options.tint && "inner" != o.options.zoomType && o.showHideTint("hide")
                        })), o.$elem.bind("mousemove", function(e) {
                            0 == o.overWindow && o.setElements("show"), o.lastX === e.clientX && o.lastY === e.clientY || (o.setPosition(e), o.currentLoc = e), o.lastX = e.clientX, o.lastY = e.clientY
                        }), o.zoomContainer.bind("mousemove", function(e) {
                            0 == o.overWindow && o.setElements("show"), o.lastX === e.clientX && o.lastY === e.clientY || (o.setPosition(e), o.currentLoc = e), o.lastX = e.clientX, o.lastY = e.clientY
                        }), "inner" != o.options.zoomType && o.zoomLens.bind("mousemove", function(e) {
                            o.lastX === e.clientX && o.lastY === e.clientY || (o.setPosition(e), o.currentLoc = e), o.lastX = e.clientX, o.lastY = e.clientY
                        }), o.options.tint && "inner" != o.options.zoomType && o.zoomTint.bind("mousemove", function(e) {
                            o.lastX === e.clientX && o.lastY === e.clientY || (o.setPosition(e), o.currentLoc = e), o.lastX = e.clientX, o.lastY = e.clientY
                        }), "inner" == o.options.zoomType && o.zoomWindow.bind("mousemove", function(e) {
                            o.lastX === e.clientX && o.lastY === e.clientY || (o.setPosition(e), o.currentLoc = e), o.lastX = e.clientX, o.lastY = e.clientY
                        }), o.zoomContainer.add(o.$elem).mouseenter(function() {
                            0 == o.overWindow && o.setElements("show")
                        }).mouseleave(function() {
                            o.scrollLock || o.setElements("hide")
                        }), "inner" != o.options.zoomType && o.zoomWindow.mouseenter(function() {
                            o.overWindow = !0, o.setElements("hide")
                        }).mouseleave(function() {
                            o.overWindow = !1
                        }), o.options.zoomLevel, o.options.minZoomLevel ? o.minZoomLevel = o.options.minZoomLevel : o.minZoomLevel = 2 * o.options.scrollZoomIncrement, o.options.scrollZoom && o.zoomContainer.add(o.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function(t) {
                            o.scrollLock = !0, clearTimeout(e.data(this, "timer")), e.data(this, "timer", setTimeout(function() {
                                o.scrollLock = !1
                            }, 250));
                            var i = t.originalEvent.wheelDelta || -1 * t.originalEvent.detail;
                            return t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault(), i / 120 > 0 ? o.currentZoomLevel >= o.minZoomLevel && o.changeZoomLevel(o.currentZoomLevel - o.options.scrollZoomIncrement) : o.options.maxZoomLevel ? o.currentZoomLevel <= o.options.maxZoomLevel && o.changeZoomLevel(parseFloat(o.currentZoomLevel) + o.options.scrollZoomIncrement) : o.changeZoomLevel(parseFloat(o.currentZoomLevel) + o.options.scrollZoomIncrement), !1
                        })
                    },
                    setElements: function(e) {
                        var o = this;
                        if (!o.options.zoomEnabled) return !1;
                        "show" == e && o.isWindowSet && ("inner" == o.options.zoomType && o.showHideWindow("show"), "window" == o.options.zoomType && o.showHideWindow("show"), o.options.showLens && o.showHideLens("show"), o.options.tint && "inner" != o.options.zoomType && o.showHideTint("show")), "hide" == e && ("window" == o.options.zoomType && o.showHideWindow("hide"), o.options.tint || o.showHideWindow("hide"), o.options.showLens && o.showHideLens("hide"), o.options.tint && o.showHideTint("hide"))
                    },
                    setPosition: function(e) {
                        var o = this;
                        if (!o.options.zoomEnabled) return !1;
                        o.nzHeight = o.$elem.height(), o.nzWidth = o.$elem.width(), o.nzOffset = o.$elem.offset(), o.options.tint && "inner" != o.options.zoomType && (o.zoomTint.css({
                            top: 0
                        }), o.zoomTint.css({
                            left: 0
                        })), o.options.responsive && !o.options.scrollZoom && o.options.showLens && (o.nzHeight < o.options.zoomWindowWidth / o.widthRatio ? lensHeight = o.nzHeight : lensHeight = String(o.options.zoomWindowHeight / o.heightRatio), o.largeWidth < o.options.zoomWindowWidth ? lensWidth = o.nzWidth : lensWidth = o.options.zoomWindowWidth / o.widthRatio, o.widthRatio = o.largeWidth / o.nzWidth, o.heightRatio = o.largeHeight / o.nzHeight, "lens" != o.options.zoomType && (o.nzHeight < o.options.zoomWindowWidth / o.widthRatio ? lensHeight = o.nzHeight : lensHeight = String(o.options.zoomWindowHeight / o.heightRatio), o.options.zoomWindowWidth < o.options.zoomWindowWidth ? lensWidth = o.nzWidth : lensWidth = o.options.zoomWindowWidth / o.widthRatio, o.zoomLens.css("width", lensWidth), o.zoomLens.css("height", lensHeight), o.options.tint && (o.zoomTintImage.css("width", o.nzWidth), o.zoomTintImage.css("height", o.nzHeight))), "lens" == o.options.zoomType && o.zoomLens.css({
                            width: String(o.options.lensSize) + "px",
                            height: String(o.options.lensSize) + "px"
                        })), o.zoomContainer.css({
                            top: o.nzOffset.top
                        }), o.zoomContainer.css({
                            left: o.nzOffset.left
                        }), o.mouseLeft = parseInt(e.pageX - o.nzOffset.left), o.mouseTop = parseInt(e.pageY - o.nzOffset.top), "window" == o.options.zoomType && (o.Etoppos = o.mouseTop < o.zoomLens.height() / 2, o.Eboppos = o.mouseTop > o.nzHeight - o.zoomLens.height() / 2 - 2 * o.options.lensBorderSize, o.Eloppos = o.mouseLeft < 0 + o.zoomLens.width() / 2, o.Eroppos = o.mouseLeft > o.nzWidth - o.zoomLens.width() / 2 - 2 * o.options.lensBorderSize), "inner" == o.options.zoomType && (o.Etoppos = o.mouseTop < o.nzHeight / 2 / o.heightRatio, o.Eboppos = o.mouseTop > o.nzHeight - o.nzHeight / 2 / o.heightRatio, o.Eloppos = o.mouseLeft < 0 + o.nzWidth / 2 / o.widthRatio, o.Eroppos = o.mouseLeft > o.nzWidth - o.nzWidth / 2 / o.widthRatio - 2 * o.options.lensBorderSize), o.mouseLeft <= 0 || o.mouseTop < 0 || o.mouseLeft > o.nzWidth || o.mouseTop > o.nzHeight ? o.setElements("hide") : (o.options.showLens && (o.lensLeftPos = String(o.mouseLeft - o.zoomLens.width() / 2), o.lensTopPos = String(o.mouseTop - o.zoomLens.height() / 2)), o.Etoppos && (o.lensTopPos = 0), o.Eloppos && (o.windowLeftPos = 0, o.lensLeftPos = 0, o.tintpos = 0), "window" == o.options.zoomType && (o.Eboppos && (o.lensTopPos = Math.max(o.nzHeight - o.zoomLens.height() - 2 * o.options.lensBorderSize, 0)), o.Eroppos && (o.lensLeftPos = o.nzWidth - o.zoomLens.width() - 2 * o.options.lensBorderSize)), "inner" == o.options.zoomType && (o.Eboppos && (o.lensTopPos = Math.max(o.nzHeight - 2 * o.options.lensBorderSize, 0)), o.Eroppos && (o.lensLeftPos = o.nzWidth - o.nzWidth - 2 * o.options.lensBorderSize)), "lens" == o.options.zoomType && (o.windowLeftPos = String(-1 * ((e.pageX - o.nzOffset.left) * o.widthRatio - o.zoomLens.width() / 2)), o.windowTopPos = String(-1 * ((e.pageY - o.nzOffset.top) * o.heightRatio - o.zoomLens.height() / 2)), o.zoomLens.css({
                            backgroundPosition: o.windowLeftPos + "px " + o.windowTopPos + "px"
                        }), o.changeBgSize && (o.nzHeight > o.nzWidth ? ("lens" == o.options.zoomType && o.zoomLens.css({
                            "background-size": o.largeWidth / o.newvalueheight + "px " + o.largeHeight / o.newvalueheight + "px"
                        }), o.zoomWindow.css({
                            "background-size": o.largeWidth / o.newvalueheight + "px " + o.largeHeight / o.newvalueheight + "px"
                        })) : ("lens" == o.options.zoomType && o.zoomLens.css({
                            "background-size": o.largeWidth / o.newvaluewidth + "px " + o.largeHeight / o.newvaluewidth + "px"
                        }), o.zoomWindow.css({
                            "background-size": o.largeWidth / o.newvaluewidth + "px " + o.largeHeight / o.newvaluewidth + "px"
                        })), o.changeBgSize = !1), o.setWindowPostition(e)), o.options.tint && "inner" != o.options.zoomType && o.setTintPosition(e), "window" == o.options.zoomType && o.setWindowPostition(e), "inner" == o.options.zoomType && o.setWindowPostition(e), o.options.showLens && (o.fullwidth && "lens" != o.options.zoomType && (o.lensLeftPos = 0), o.zoomLens.css({
                            left: o.lensLeftPos + "px",
                            top: o.lensTopPos + "px"
                        })))
                    },
                    showHideWindow: function(e) {
                        var o = this;
                        "show" == e && (o.isWindowActive || (o.options.zoomWindowFadeIn ? o.zoomWindow.stop(!0, !0, !1).fadeIn(o.options.zoomWindowFadeIn) : o.zoomWindow.show(), o.isWindowActive = !0)), "hide" == e && o.isWindowActive && (o.options.zoomWindowFadeOut ? o.zoomWindow.stop(!0, !0).fadeOut(o.options.zoomWindowFadeOut) : o.zoomWindow.hide(), o.isWindowActive = !1)
                    },
                    showHideLens: function(e) {
                        var o = this;
                        "show" == e && (o.isLensActive || (o.options.lensFadeIn ? o.zoomLens.stop(!0, !0, !1).fadeIn(o.options.lensFadeIn) : o.zoomLens.show(), o.isLensActive = !0)), "hide" == e && o.isLensActive && (o.options.lensFadeOut ? o.zoomLens.stop(!0, !0).fadeOut(o.options.lensFadeOut) : o.zoomLens.hide(), o.isLensActive = !1)
                    },
                    showHideTint: function(e) {
                        var o = this;
                        "show" == e && (o.isTintActive || (o.options.zoomTintFadeIn ? o.zoomTint.css({
                            opacity: o.options.tintOpacity
                        }).animate().stop(!0, !0).fadeIn("slow") : (o.zoomTint.css({
                            opacity: o.options.tintOpacity
                        }).animate(), o.zoomTint.show()), o.isTintActive = !0)), "hide" == e && o.isTintActive && (o.options.zoomTintFadeOut ? o.zoomTint.stop(!0, !0).fadeOut(o.options.zoomTintFadeOut) : o.zoomTint.hide(), o.isTintActive = !1)
                    },
                    setLensPostition: function(e) {},
                    setWindowPostition: function(o) {
                        var t = this;
                        if (isNaN(t.options.zoomWindowPosition)) t.externalContainer = e("#" + t.options.zoomWindowPosition), t.externalContainerWidth = t.externalContainer.width(), t.externalContainerHeight = t.externalContainer.height(), t.externalContainerOffset = t.externalContainer.offset(), t.windowOffsetTop = t.externalContainerOffset.top, t.windowOffsetLeft = t.externalContainerOffset.left;
                        else switch (t.options.zoomWindowPosition) {
                            case 1:
                                t.windowOffsetTop = t.options.zoomWindowOffety, t.windowOffsetLeft = +t.nzWidth;
                                break;
                            case 2:
                                t.options.zoomWindowHeight > t.nzHeight && (t.windowOffsetTop = -1 * (t.options.zoomWindowHeight / 2 - t.nzHeight / 2), t.windowOffsetLeft = t.nzWidth);
                                break;
                            case 3:
                                t.windowOffsetTop = t.nzHeight - t.zoomWindow.height() - 2 * t.options.borderSize, t.windowOffsetLeft = t.nzWidth;
                                break;
                            case 4:
                                t.windowOffsetTop = t.nzHeight, t.windowOffsetLeft = t.nzWidth;
                                break;
                            case 5:
                                t.windowOffsetTop = t.nzHeight, t.windowOffsetLeft = t.nzWidth - t.zoomWindow.width() - 2 * t.options.borderSize;
                                break;
                            case 6:
                                t.options.zoomWindowHeight > t.nzHeight && (t.windowOffsetTop = t.nzHeight, t.windowOffsetLeft = -1 * (t.options.zoomWindowWidth / 2 - t.nzWidth / 2 + 2 * t.options.borderSize));
                                break;
                            case 7:
                                t.windowOffsetTop = t.nzHeight, t.windowOffsetLeft = 0;
                                break;
                            case 8:
                                t.windowOffsetTop = t.nzHeight, t.windowOffsetLeft = -1 * (t.zoomWindow.width() + 2 * t.options.borderSize);
                                break;
                            case 9:
                                t.windowOffsetTop = t.nzHeight - t.zoomWindow.height() - 2 * t.options.borderSize, t.windowOffsetLeft = -1 * (t.zoomWindow.width() + 2 * t.options.borderSize);
                                break;
                            case 10:
                                t.options.zoomWindowHeight > t.nzHeight && (t.windowOffsetTop = -1 * (t.options.zoomWindowHeight / 2 - t.nzHeight / 2), t.windowOffsetLeft = -1 * (t.zoomWindow.width() + 2 * t.options.borderSize));
                                break;
                            case 11:
                                t.windowOffsetTop = t.options.zoomWindowOffety, t.windowOffsetLeft = -1 * (t.zoomWindow.width() + 2 * t.options.borderSize);
                                break;
                            case 12:
                                t.windowOffsetTop = -1 * (t.zoomWindow.height() + 2 * t.options.borderSize), t.windowOffsetLeft = -1 * (t.zoomWindow.width() + 2 * t.options.borderSize);
                                break;
                            case 13:
                                t.windowOffsetTop = -1 * (t.zoomWindow.height() + 2 * t.options.borderSize), t.windowOffsetLeft = 0;
                                break;
                            case 14:
                                t.options.zoomWindowHeight > t.nzHeight && (t.windowOffsetTop = -1 * (t.zoomWindow.height() + 2 * t.options.borderSize), t.windowOffsetLeft = -1 * (t.options.zoomWindowWidth / 2 - t.nzWidth / 2 + 2 * t.options.borderSize));
                                break;
                            case 15:
                                t.windowOffsetTop = -1 * (t.zoomWindow.height() + 2 * t.options.borderSize), t.windowOffsetLeft = t.nzWidth - t.zoomWindow.width() - 2 * t.options.borderSize;
                                break;
                            case 16:
                                t.windowOffsetTop = -1 * (t.zoomWindow.height() + 2 * t.options.borderSize), t.windowOffsetLeft = t.nzWidth;
                                break;
                            default:
                                t.windowOffsetTop = t.options.zoomWindowOffety, t.windowOffsetLeft = t.nzWidth
                        }
                        t.isWindowSet = !0, t.windowOffsetTop = t.windowOffsetTop + t.options.zoomWindowOffety, t.windowOffsetLeft = t.windowOffsetLeft + t.options.zoomWindowOffetx, t.zoomWindow.css({
                            top: t.windowOffsetTop
                        }), t.zoomWindow.css({
                            left: t.windowOffsetLeft
                        }), "inner" == t.options.zoomType && (t.zoomWindow.css({
                            top: 0
                        }), t.zoomWindow.css({
                            left: 0
                        })), t.windowLeftPos = String(-1 * ((o.pageX - t.nzOffset.left) * t.widthRatio - t.zoomWindow.width() / 2)), t.windowTopPos = String(-1 * ((o.pageY - t.nzOffset.top) * t.heightRatio - t.zoomWindow.height() / 2)), t.Etoppos && (t.windowTopPos = 0), t.Eloppos && (t.windowLeftPos = 0), t.Eboppos && (t.windowTopPos = -1 * (t.largeHeight / t.currentZoomLevel - t.zoomWindow.height())), t.Eroppos && (t.windowLeftPos = -1 * (t.largeWidth / t.currentZoomLevel - t.zoomWindow.width())), t.fullheight && (t.windowTopPos = 0), t.fullwidth && (t.windowLeftPos = 0), "window" != t.options.zoomType && "inner" != t.options.zoomType || (1 == t.zoomLock && (t.widthRatio <= 1 && (t.windowLeftPos = 0), t.heightRatio <= 1 && (t.windowTopPos = 0)), t.largeHeight < t.options.zoomWindowHeight && (t.windowTopPos = 0), t.largeWidth < t.options.zoomWindowWidth && (t.windowLeftPos = 0), t.options.easing ? (t.xp || (t.xp = 0), t.yp || (t.yp = 0), t.loop || (t.loop = setInterval(function() {
                            t.xp += (t.windowLeftPos - t.xp) / t.options.easingAmount, t.yp += (t.windowTopPos - t.yp) / t.options.easingAmount, t.scrollingLock ? (clearInterval(t.loop), t.xp = t.windowLeftPos, t.yp = t.windowTopPos, t.xp = -1 * ((o.pageX - t.nzOffset.left) * t.widthRatio - t.zoomWindow.width() / 2), t.yp = -1 * ((o.pageY - t.nzOffset.top) * t.heightRatio - t.zoomWindow.height() / 2), t.changeBgSize && (t.nzHeight > t.nzWidth ? ("lens" == t.options.zoomType && t.zoomLens.css({
                                "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                            }), t.zoomWindow.css({
                                "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                            })) : ("lens" != t.options.zoomType && t.zoomLens.css({
                                "background-size": t.largeWidth / t.newvaluewidth + "px " + t.largeHeight / t.newvalueheight + "px"
                            }), t.zoomWindow.css({
                                "background-size": t.largeWidth / t.newvaluewidth + "px " + t.largeHeight / t.newvaluewidth + "px"
                            })), t.changeBgSize = !1), t.zoomWindow.css({
                                backgroundPosition: t.windowLeftPos + "px " + t.windowTopPos + "px"
                            }), t.scrollingLock = !1, t.loop = !1) : (t.changeBgSize && (t.nzHeight > t.nzWidth ? ("lens" == t.options.zoomType && t.zoomLens.css({
                                "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                            }), t.zoomWindow.css({
                                "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                            })) : ("lens" != t.options.zoomType && t.zoomLens.css({
                                "background-size": t.largeWidth / t.newvaluewidth + "px " + t.largeHeight / t.newvaluewidth + "px"
                            }), t.zoomWindow.css({
                                "background-size": t.largeWidth / t.newvaluewidth + "px " + t.largeHeight / t.newvaluewidth + "px"
                            })), t.changeBgSize = !1), t.zoomWindow.css({
                                backgroundPosition: t.xp + "px " + t.yp + "px"
                            }))
                        }, 16))) : (t.changeBgSize && (t.nzHeight > t.nzWidth ? ("lens" == t.options.zoomType && t.zoomLens.css({
                            "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                        }), t.zoomWindow.css({
                            "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                        })) : ("lens" == t.options.zoomType && t.zoomLens.css({
                            "background-size": t.largeWidth / t.newvaluewidth + "px " + t.largeHeight / t.newvaluewidth + "px"
                        }), t.largeHeight / t.newvaluewidth < t.options.zoomWindowHeight ? t.zoomWindow.css({
                            "background-size": t.largeWidth / t.newvaluewidth + "px " + t.largeHeight / t.newvaluewidth + "px"
                        }) : t.zoomWindow.css({
                            "background-size": t.largeWidth / t.newvalueheight + "px " + t.largeHeight / t.newvalueheight + "px"
                        })), t.changeBgSize = !1), t.zoomWindow.css({
                            backgroundPosition: t.windowLeftPos + "px " + t.windowTopPos + "px"
                        })))
                    },
                    setTintPosition: function(e) {
                        var o = this;
                        o.nzOffset = o.$elem.offset(), o.tintpos = String(-1 * (e.pageX - o.nzOffset.left - o.zoomLens.width() / 2)), o.tintposy = String(-1 * (e.pageY - o.nzOffset.top - o.zoomLens.height() / 2)), o.Etoppos && (o.tintposy = 0), o.Eloppos && (o.tintpos = 0), o.Eboppos && (o.tintposy = -1 * (o.nzHeight - o.zoomLens.height() - 2 * o.options.lensBorderSize)), o.Eroppos && (o.tintpos = -1 * (o.nzWidth - o.zoomLens.width() - 2 * o.options.lensBorderSize)), o.options.tint && (o.fullheight && (o.tintposy = 0), o.fullwidth && (o.tintpos = 0), o.zoomTintImage.css({
                            left: o.tintpos + "px"
                        }), o.zoomTintImage.css({
                            top: o.tintposy + "px"
                        }))
                    },
                    swaptheimage: function(o, t) {
                        var i = this,
                            n = new Image;
                        i.options.loadingIcon && e.scafancybox.showLoading(), i.options.onImageSwap(i.$elem), n.onload = function() {
                            i.largeWidth = n.width, i.largeHeight = n.height, i.zoomImage = t, i.zoomWindow.css({
                                "background-size": i.largeWidth + "px " + i.largeHeight + "px"
                            }), i.zoomWindow.css({
                                "background-size": i.largeWidth + "px " + i.largeHeight + "px"
                            }), i.swapAction(o, t)
                        }, n.src = t
                    },
                    swapAction: function(o, t) {
                        var i = this,
                            n = new Image;
                        if (n.onload = function() {
                                i.nzHeight = n.height, i.nzWidth = n.width, i.options.onImageSwapComplete(i.$elem), i.doneCallback()
                            }, n.src = o, i.currentZoomLevel = i.options.zoomLevel, i.options.maxZoomLevel = !1, "lens" == i.options.zoomType && i.zoomLens.css({
                                backgroundImage: "url('" + t + "')"
                            }), "window" == i.options.zoomType && i.zoomWindow.css({
                                backgroundImage: "url('" + t + "')"
                            }), "inner" == i.options.zoomType && i.zoomWindow.css({
                                backgroundImage: "url('" + t + "')"
                            }), i.currentImage = t, i.options.imageCrossfade) {
                            var a = i.$elem,
                                s = a.clone();
                            if (i.$elem.attr("src", o), i.$elem.after(s), s.stop(!0).fadeOut(i.options.imageCrossfade, function() {
                                    e(this).remove()
                                }), i.$elem.width("auto").removeAttr("width"), i.$elem.height("auto").removeAttr("height"), a.fadeIn(i.options.imageCrossfade), i.options.tint && "inner" != i.options.zoomType) {
                                var r = i.zoomTintImage,
                                    c = r.clone();
                                i.zoomTintImage.attr("src", t), i.zoomTintImage.after(c), c.stop(!0).fadeOut(i.options.imageCrossfade, function() {
                                    e(this).remove()
                                }), r.fadeIn(i.options.imageCrossfade), i.zoomTint.css({
                                    height: i.$elem.height()
                                }), i.zoomTint.css({
                                    width: i.$elem.width()
                                })
                            }
                            i.zoomContainer.css("height", i.$elem.height()), i.zoomContainer.css("width", i.$elem.width()), "inner" == i.options.zoomType && (i.options.constrainType || (i.zoomWrap.parent().css("height", i.$elem.height()), i.zoomWrap.parent().css("width", i.$elem.width()), i.zoomWindow.css("height", i.$elem.height()), i.zoomWindow.css("width", i.$elem.width()))), i.options.imageCrossfade && (i.zoomWrap.css("height", i.$elem.height()), i.zoomWrap.css("width", i.$elem.width()))
                        } else i.$elem.attr("src", o), i.options.tint && (i.zoomTintImage.attr("src", t), i.zoomTintImage.attr("height", i.$elem.height()), i.zoomTintImage.css({
                            height: i.$elem.height()
                        }), i.zoomTint.css({
                            height: i.$elem.height()
                        })), i.zoomContainer.css("height", i.$elem.height()), i.zoomContainer.css("width", i.$elem.width()), i.options.imageCrossfade && (i.zoomWrap.css("height", i.$elem.height()), i.zoomWrap.css("width", i.$elem.width()));
                        i.options.constrainType && ("height" == i.options.constrainType && (i.zoomContainer.css("height", i.options.constrainSize), i.zoomContainer.css("width", "auto"), i.options.imageCrossfade ? (i.zoomWrap.css("height", i.options.constrainSize), i.zoomWrap.css("width", "auto"), i.constwidth = i.zoomWrap.width()) : (i.$elem.css("height", i.options.constrainSize), i.$elem.css("width", "auto"), i.constwidth = i.$elem.width()), "inner" == i.options.zoomType && (i.zoomWrap.parent().css("height", i.options.constrainSize), i.zoomWrap.parent().css("width", i.constwidth), i.zoomWindow.css("height", i.options.constrainSize), i.zoomWindow.css("width", i.constwidth)), i.options.tint && (i.tintContainer.css("height", i.options.constrainSize), i.tintContainer.css("width", i.constwidth), i.zoomTint.css("height", i.options.constrainSize), i.zoomTint.css("width", i.constwidth), i.zoomTintImage.css("height", i.options.constrainSize), i.zoomTintImage.css("width", i.constwidth))), "width" == i.options.constrainType && (i.zoomContainer.css("height", "auto"), i.zoomContainer.css("width", i.options.constrainSize), i.options.imageCrossfade ? (i.zoomWrap.css("height", "auto"), i.zoomWrap.css("width", i.options.constrainSize), i.constheight = i.zoomWrap.height()) : (i.$elem.css("height", "auto"), i.$elem.css("width", i.options.constrainSize), i.constheight = i.$elem.height()), "inner" == i.options.zoomType && (i.zoomWrap.parent().css("height", i.constheight), i.zoomWrap.parent().css("width", i.options.constrainSize), i.zoomWindow.css("height", i.constheight), i.zoomWindow.css("width", i.options.constrainSize)), i.options.tint && (i.tintContainer.css("height", i.constheight), i.tintContainer.css("width", i.options.constrainSize), i.zoomTint.css("height", i.constheight), i.zoomTint.css("width", i.options.constrainSize), i.zoomTintImage.css("height", i.constheight), i.zoomTintImage.css("width", i.options.constrainSize))))
                    },
                    doneCallback: function() {
                        var o = this;
                        e.scafancybox.hideLoading(), o.nzOffset = o.$elem.offset(), o.nzWidth = o.$elem.width(), o.nzHeight = o.$elem.height(), e.scafancybox.scaupdate(), o.currentZoomLevel = o.options.zoomLevel, o.widthRatio = o.largeWidth / o.nzWidth, o.heightRatio = o.largeHeight / o.nzHeight, "window" == o.options.zoomType && (o.nzHeight < o.options.zoomWindowWidth / o.widthRatio ? lensHeight = o.nzHeight : lensHeight = String(o.options.zoomWindowHeight / o.heightRatio), o.options.zoomWindowWidth < o.options.zoomWindowWidth ? lensWidth = o.nzWidth : lensWidth = o.options.zoomWindowWidth / o.widthRatio, o.zoomLens && (o.zoomLens.css("width", lensWidth), o.zoomLens.css("height", lensHeight)))
                    },
                    getCurrentImage: function() {
                        return this.zoomImage
                    },
                    getGalleryList: function() {
                        var o = this;
                        return o.gallerylist = [], o.options.gallery ? e("#" + o.options.gallery + " a").each(function() {
                            var t = "";
                            e(this).data("zoom-image") ? t = e(this).data("zoom-image") : e(this).data("image") && (t = e(this).data("image")), t == o.zoomImage ? o.gallerylist.unshift({
                                href: "" + t,
                                title: e(this).find("img").attr("title")
                            }) : o.gallerylist.push({
                                href: "" + t,
                                title: e(this).find("img").attr("title")
                            })
                        }) : o.gallerylist.push({
                            href: "" + o.zoomImage,
                            title: e(this).find("img").attr("title")
                        }), o.gallerylist
                    },
                    changeZoomLevel: function(e) {
                        var o = this;
                        o.scrollingLock = !0, o.newvalue = parseFloat(e).toFixed(2), newvalue = parseFloat(e).toFixed(2), maxheightnewvalue = o.largeHeight / (o.options.zoomWindowHeight / o.nzHeight * o.nzHeight), maxwidthtnewvalue = o.largeWidth / (o.options.zoomWindowWidth / o.nzWidth * o.nzWidth), "inner" != o.options.zoomType && (maxheightnewvalue <= newvalue ? (o.heightRatio = o.largeHeight / maxheightnewvalue / o.nzHeight, o.newvalueheight = maxheightnewvalue, o.fullheight = !0) : (o.heightRatio = o.largeHeight / newvalue / o.nzHeight, o.newvalueheight = newvalue, o.fullheight = !1), maxwidthtnewvalue <= newvalue ? (o.widthRatio = o.largeWidth / maxwidthtnewvalue / o.nzWidth, o.newvaluewidth = maxwidthtnewvalue, o.fullwidth = !0) : (o.widthRatio = o.largeWidth / newvalue / o.nzWidth, o.newvaluewidth = newvalue, o.fullwidth = !1), "lens" == o.options.zoomType && (maxheightnewvalue <= newvalue ? (o.fullwidth = !0, o.newvaluewidth = maxheightnewvalue) : (o.widthRatio = o.largeWidth / newvalue / o.nzWidth, o.newvaluewidth = newvalue, o.fullwidth = !1))), "inner" == o.options.zoomType && (maxheightnewvalue = parseFloat(o.largeHeight / o.nzHeight).toFixed(2), maxwidthtnewvalue = parseFloat(o.largeWidth / o.nzWidth).toFixed(2), newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue), newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue), maxheightnewvalue <= newvalue ? (o.heightRatio = o.largeHeight / newvalue / o.nzHeight, newvalue > maxheightnewvalue ? o.newvalueheight = maxheightnewvalue : o.newvalueheight = newvalue, o.fullheight = !0) : (o.heightRatio = o.largeHeight / newvalue / o.nzHeight, newvalue > maxheightnewvalue ? o.newvalueheight = maxheightnewvalue : o.newvalueheight = newvalue, o.fullheight = !1), maxwidthtnewvalue <= newvalue ? (o.widthRatio = o.largeWidth / newvalue / o.nzWidth, newvalue > maxwidthtnewvalue ? o.newvaluewidth = maxwidthtnewvalue : o.newvaluewidth = newvalue, o.fullwidth = !0) : (o.widthRatio = o.largeWidth / newvalue / o.nzWidth, o.newvaluewidth = newvalue, o.fullwidth = !1)), scrcontinue = !1, "inner" == o.options.zoomType && (o.nzWidth > o.nzHeight && (o.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, o.fullheight = !0, o.fullwidth = !0)), o.nzHeight > o.nzWidth && (o.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, o.fullheight = !0, o.fullwidth = !0))), "inner" != o.options.zoomType && (scrcontinue = !0), scrcontinue && (o.zoomLock = 0, o.changeZoom = !0, o.options.zoomWindowHeight / o.heightRatio <= o.nzHeight && (o.currentZoomLevel = o.newvalueheight, "lens" != o.options.zoomType && "inner" != o.options.zoomType && (o.changeBgSize = !0, o.zoomLens.css({
                            height: String(o.options.zoomWindowHeight / o.heightRatio) + "px"
                        })), "lens" != o.options.zoomType && "inner" != o.options.zoomType || (o.changeBgSize = !0)), o.options.zoomWindowWidth / o.widthRatio <= o.nzWidth && ("inner" != o.options.zoomType && o.newvaluewidth > o.newvalueheight && (o.currentZoomLevel = o.newvaluewidth), "lens" != o.options.zoomType && "inner" != o.options.zoomType && (o.changeBgSize = !0, o.zoomLens.css({
                            width: String(o.options.zoomWindowWidth / o.widthRatio) + "px"
                        })), "lens" != o.options.zoomType && "inner" != o.options.zoomType || (o.changeBgSize = !0)), "inner" == o.options.zoomType && (o.changeBgSize = !0, o.nzWidth > o.nzHeight && (o.currentZoomLevel = o.newvaluewidth), o.nzHeight > o.nzWidth && (o.currentZoomLevel = o.newvaluewidth))), o.setPosition(o.currentLoc)
                    },
                    closeAll: function() {
                        self.zoomWindow && self.zoomWindow.hide(), self.zoomLens && self.zoomLens.hide(), self.zoomTint && self.zoomTint.hide()
                    },
                    changeState: function(e) {
                        var o = this;
                        "enable" == e && (o.options.zoomEnabled = !0), "disable" == e && (o.options.zoomEnabled = !1)
                    }
                };
                e.fn.elevateZoom = function(o) {
                    return this.each(function() {
                        var t = Object.create(n);
                        t.init(o, this), e.data(this, "elevateZoom", t)
                    })
                }, e.fn.elevateZoom.options = {
                    zoomActivation: "hover",
                    zoomEnabled: !0,
                    preloading: 1,
                    zoomLevel: 1,
                    scrollZoom: !1,
                    scrollZoomIncrement: .1,
                    minZoomLevel: !1,
                    maxZoomLevel: !1,
                    easing: !1,
                    easingAmount: 12,
                    lensSize: 200,
                    zoomWindowWidth: 400,
                    zoomWindowHeight: 400,
                    zoomWindowOffetx: 0,
                    zoomWindowOffety: 0,
                    zoomWindowPosition: 1,
                    zoomWindowBgColour: "#fff",
                    lensFadeIn: !1,
                    lensFadeOut: !1,
                    debug: !1,
                    zoomWindowFadeIn: !1,
                    zoomWindowFadeOut: !1,
                    zoomWindowAlwaysShow: !1,
                    zoomTintFadeIn: !1,
                    zoomTintFadeOut: !1,
                    borderSize: 4,
                    showLens: !0,
                    borderColour: "#888",
                    lensBorderSize: 1,
                    lensBorderColour: "#000",
                    lensShape: "square",
                    zoomType: "window",
                    containLensZoom: !1,
                    lensColour: "white",
                    lensOpacity: .4,
                    lenszoom: !1,
                    tint: !1,
                    tintColour: "#333",
                    tintOpacity: .4,
                    gallery: !1,
                    galleryActiveClass: "zoomGalleryActive",
                    imageCrossfade: !1,
                    constrainType: !1,
                    constrainSize: !1,
                    loadingIcon: "data:image/gif;base64,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",
                    cursor: "default",
                    responsive: !0,
                    onComplete: e.noop,
                    onZoomedImageLoaded: function() {},
                    onImageSwap: e.noop,
                    onImageSwapComplete: e.noop
                }
            }(e)
    }

    function scaqvFancybox(e, o, t, i) {
        "use strict";
        var n = t("html"),
            a = t(e),
            s = t(o),
            r = t.scafancybox = function() {
                r.open.apply(this, arguments)
            },
            c = navigator.userAgent.match(/msie/i),
            l = null,
            d = o.createTouch !== i,
            h = function(e) {
                return e && e.hasOwnProperty && e instanceof t
            },
            p = function(e) {
                return e && "string" === t.type(e)
            },
            g = function(e) {
                return p(e) && e.indexOf("%") > 0
            },
            m = function(e) {
                return e && !(e.style.overflow && "hidden" === e.style.overflow) && (e.clientWidth && e.scrollWidth > e.clientWidth || e.clientHeight && e.scrollHeight > e.clientHeight)
            },
            u = function(e, o) {
                var t = parseInt(e, 10) || 0;
                return o && g(e) && (t = r.getViewport()[o] / 100 * t), Math.ceil(t)
            },
            w = function(e, o) {
                return u(e, o) + "px"
            };
        t.extend(r, {
            version: "2.1.5",
            defaults: {
                padding: 15,
                margin: 20,
                width: 800,
                height: 600,
                minWidth: 100,
                minHeight: 100,
                maxWidth: 9999,
                maxHeight: 9999,
                pixelRatio: 2,
                autoSize: !0,
                autoHeight: !1,
                autoWidth: !1,
                autoResize: !0,
                autoCenter: !d,
                fitToView: !0,
                aspectRatio: !1,
                topRatio: .5,
                leftRatio: .5,
                scrolling: "auto",
                wrapCSS: "",
                arrows: !0,
                closeBtn: !0,
                closeClick: !1,
                nextClick: !1,
                mouseWheel: !0,
                autoPlay: !1,
                playSpeed: 3e3,
                preload: 3,
                modal: !1,
                loop: !0,
                ajax: {
                    dataType: "html",
                    headers: {
                        "X-sca-fancybox": !0
                    }
                },
                iframe: {
                    scrolling: "auto",
                    preload: !0
                },
                swf: {
                    wmode: "transparent",
                    allowfullscreen: "true",
                    allowscriptaccess: "always"
                },
                keys: {
                    next: {
                        13: "left",
                        34: "up",
                        39: "left",
                        40: "up"
                    },
                    prev: {
                        8: "right",
                        33: "down",
                        37: "right",
                        38: "down"
                    },
                    close: [27],
                    play: [32],
                    toggle: [70]
                },
                direction: {
                    next: "left",
                    prev: "right"
                },
                scrollOutside: !0,
                index: 0,
                type: null,
                href: null,
                content: null,
                title: null,
                tpl: {
                    wrap: '<div class="sca-fancybox-wrap" tabIndex="-1"><div class="sca-fancybox-skin"><div class="sca-fancybox-outer"><div class="sca-fancybox-inner"></div></div></div></div>',
                    image: '<img class="sca-fancybox-image" src="{href}" alt="" />',
                    iframe: '<iframe id="sca-fancybox-frame{rnd}" name="sca-fancybox-frame{rnd}" class="sca-fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (c ? ' allowtransparency="true"' : "") + "></iframe>",
                    error: '<p class="sca-fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                    closeBtn: '<a title="Close" class="sca-fancybox-item sca-fancybox-close" href="javascript:;"></a>',
                    next: '<a title="Next" class="sca-fancybox-nav sca-fancybox-next" href="javascript:;"><span></span></a>',
                    prev: '<a title="Previous" class="sca-fancybox-nav sca-fancybox-prev" href="javascript:;"><span></span></a>'
                },
                openEffect: "fade",
                openSpeed: 250,
                openEasing: "swing",
                openOpacity: !0,
                openMethod: "zoomIn",
                closeEffect: "fade",
                closeSpeed: 250,
                closeEasing: "swing",
                closeOpacity: !0,
                closeMethod: "zoomOut",
                nextEffect: "elastic",
                nextSpeed: 250,
                nextEasing: "swing",
                nextMethod: "changeIn",
                prevEffect: "elastic",
                prevSpeed: 250,
                prevEasing: "swing",
                prevMethod: "changeOut",
                helpers: {
                    overlay: !0,
                    title: !0
                },
                onCancel: t.noop,
                beforeLoad: t.noop,
                afterLoad: t.noop,
                beforeShow: t.noop,
                afterShow: t.noop,
                beforeChange: t.noop,
                beforeClose: t.noop,
                afterClose: t.noop
            },
            group: {},
            opts: {},
            previous: null,
            coming: null,
            current: null,
            isActive: !1,
            isOpen: !1,
            isOpened: !1,
            wrap: null,
            skin: null,
            outer: null,
            inner: null,
            player: {
                timer: null,
                isActive: !1
            },
            ajaxLoad: null,
            imgPreload: null,
            transitions: {},
            helpers: {},
            open: function(e, o) {
                if (e && (t.isPlainObject(o) || (o = {}), !1 !== r.close(!0))) return t.isArray(e) || (e = h(e) ? t(e).get() : [e]), t.each(e, function(n, a) {
                    var s, c, l, d, g, m, u, w = {};
                    "object" === t.type(a) && (a.nodeType && (a = t(a)), h(a) ? (w = {
                        href: a.data("sca-fancybox-href") || a.attr("href"),
                        title: a.data("sca-fancybox-title") || a.attr("title"),
                        isDom: !0,
                        element: a
                    }, t.metadata && t.extend(!0, w, a.metadata())) : w = a), s = o.href || w.href || (p(a) ? a : null), c = o.title !== i ? o.title : w.title || "", !(d = (l = o.content || w.content) ? "html" : o.type || w.type) && w.isDom && ((d = a.data("sca-fancybox-type")) || (d = (g = a.prop("class").match(/sca-fancybox\.(\w+)/)) ? g[1] : null)), p(s) && (d || (r.isImage(s) ? d = "image" : r.isSWF(s) ? d = "swf" : "#" === s.charAt(0) ? d = "inline" : p(a) && (d = "html", l = a)), "ajax" === d && (s = (m = s.split(/\s+/, 2)).shift(), u = m.shift())), l || ("inline" === d ? s ? l = t(p(s) ? s.replace(/.*(?=#[^\s]+$)/, "") : s) : w.isDom && (l = a) : "html" === d ? l = s : d || s || !w.isDom || (d = "inline", l = a)), t.extend(w, {
                        href: s,
                        type: d,
                        content: l,
                        title: c,
                        selector: u
                    }), e[n] = w
                }), r.opts = t.extend(!0, {}, r.defaults, o), o.keys !== i && (r.opts.keys = !!o.keys && t.extend({}, r.defaults.keys, o.keys)), r.group = e, r._start(r.opts.index)
            },
            cancel: function() {
                var e = r.coming;
                e && !1 !== r.trigger("onCancel") && (r.hideLoading(), r.ajaxLoad && r.ajaxLoad.abort(), r.ajaxLoad = null, r.imgPreload && (r.imgPreload.onload = r.imgPreload.onerror = null), e.wrap && e.wrap.stop(!0, !0).trigger("onReset").remove(), r.coming = null, r.current || r._afterZoomOut(e))
            },
            close: function(e) {
                r.cancel(), !1 !== r.trigger("beforeClose") && (r.unbindEvents(), r.isActive && (r.isOpen && !0 !== e ? (r.isOpen = r.isOpened = !1, r.isClosing = !0, t(".sca-fancybox-item, .sca-fancybox-nav").remove(), r.wrap.stop(!0, !0).removeClass("sca-fancybox-opened"), r.transitions[r.current.closeMethod]()) : (t(".sca-fancybox-wrap").stop(!0).trigger("onReset").remove(), r._afterZoomOut())))
            },
            play: function(e) {
                var o = function() {
                        clearTimeout(r.player.timer)
                    },
                    t = function() {
                        o(), r.current && r.player.isActive && (r.player.timer = setTimeout(r.next, r.current.playSpeed))
                    },
                    i = function() {
                        o(), s.unbind(".player"), r.player.isActive = !1, r.trigger("onPlayEnd")
                    };
                !0 === e || !r.player.isActive && !1 !== e ? r.current && (r.current.loop || r.current.index < r.group.length - 1) && (r.player.isActive = !0, s.bind({
                    "onCancel.player beforeClose.player": i,
                    "onUpdate.player": t,
                    "beforeLoad.player": o
                }), t(), r.trigger("onPlayStart")) : i()
            },
            next: function(e) {
                var o = r.current;
                o && (p(e) || (e = o.direction.next), r.jumpto(o.index + 1, e, "next"))
            },
            prev: function(e) {
                var o = r.current;
                o && (p(e) || (e = o.direction.prev), r.jumpto(o.index - 1, e, "prev"))
            },
            jumpto: function(e, o, t) {
                var n = r.current;
                n && (e = u(e), r.direction = o || n.direction[e >= n.index ? "next" : "prev"], r.router = t || "jumpto", n.loop && (e < 0 && (e = n.group.length + e % n.group.length), e %= n.group.length), n.group[e] !== i && (r.cancel(), r._start(e)))
            },
            reposition: function(e, o) {
                var i, n = r.current,
                    a = n ? n.wrap : null;
                a && (i = r._getPosition(o), e && "scroll" === e.type ? (delete i.position, a.stop(!0, !0).animate(i, 200)) : (a.css(i), n.pos = t.extend({}, n.dim, i)))
            },
            update: function(e) {
                var o = e && e.type,
                    t = !o || "orientationchange" === o;
                t && (clearTimeout(l), l = null), r.isOpen && !l && (l = setTimeout(function() {
                    var i = r.current;
                    i && !r.isClosing && (r.wrap.removeClass("sca-fancybox-tmp"), (t || "load" === o || "resize" === o && i.autoResize) && r._setDimension(), "scroll" === o && i.canShrink || r.reposition(e), r.trigger("onUpdate"), l = null)
                }, t && !d ? 0 : 300))
            },
            scaupdate: function(e) {
                var o = e && e.type;
                if (clearTimeout(l), l = null, r.isOpen && !l) {
                    var i = 0;
                    i = t("#sca-qv-left").outerHeight() > t(".sca-fancybox-inner").outerHeight() ? 345 : 0, 0 == t("#sca-qv-zoomcontainer").outerHeight() && t("#sca-qv-left").outerHeight() !== t(".sca-fancybox-inner").outerHeight() && (0 == i && (i = 345), t("#sca-qv-zoomcontainer").height(t("#sca-qv-zoomImg").outerHeight())), l = setTimeout(function() {
                        var t = r.current;
                        t && !r.isClosing && (r.wrap.removeClass("sca-fancybox-tmp"), r._setDimension(), "scroll" === o && t.canShrink || r.reposition(e), r.trigger("onUpdate"), l = null, r.hideLoading())
                    }, i)
                }
            },
            toggle: function(e) {
                r.isOpen && (r.current.fitToView = "boolean" === t.type(e) ? e : !r.current.fitToView, d && (r.wrap.removeAttr("style").addClass("sca-fancybox-tmp"), r.trigger("onUpdate")), r.update())
            },
            hideLoading: function() {
                s.unbind(".loading"), t("#sca-fancybox-loading").remove()
            },
            showLoading: function() {
                var e, o;
                r.hideLoading(), e = t('<div id="sca-fancybox-loading"><div></div></div>').click(r.cancel).appendTo("body"), s.bind("keydown.loading", function(e) {
                    27 === (e.which || e.keyCode) && (e.preventDefault(), r.cancel())
                }), r.defaults.fixed || (o = r.getViewport(), e.css({
                    position: "absolute",
                    top: .5 * o.h + o.y,
                    left: .5 * o.w + o.x
                }))
            },
            getViewport: function() {
                var o = r.current && r.current.locked || !1,
                    t = {
                        x: a.scrollLeft(),
                        y: a.scrollTop()
                    };
                return o ? (t.w = o[0].clientWidth, t.h = o[0].clientHeight) : (t.w = d && e.innerWidth ? e.innerWidth : a.width(), t.h = d || e.innerHeight ? e.innerHeight : a.height()), t
            },
            unbindEvents: function() {
                r.wrap && h(r.wrap) && r.wrap.unbind(".fb"), s.unbind(".fb"), a.unbind(".fb")
            },
            bindEvents: function() {
                var e, o = r.current;
                o && (a.bind("orientationchange.fb" + (d ? "" : " resize.fb") + (o.autoCenter && !o.locked ? " scroll.fb" : ""), r.update), (e = o.keys) && s.bind("keydown.fb", function(n) {
                    var a = n.which || n.keyCode,
                        s = n.target || n.srcElement;
                    if (27 === a && r.coming) return !1;
                    n.ctrlKey || n.altKey || n.shiftKey || n.metaKey || s && (s.type || t(s).is("[contenteditable]")) || t.each(e, function(e, s) {
                        return o.group.length > 1 && s[a] !== i ? (r[e](s[a]), n.preventDefault(), !1) : t.inArray(a, s) > -1 ? (r[e](), n.preventDefault(), !1) : void 0
                    })
                }), t.fn.mousewheel && o.mouseWheel && r.wrap.bind("mousewheel.fb", function(e, i, n, a) {
                    for (var s = e.target || null, c = t(s), l = !1; c.length && !(l || c.is(".sca-fancybox-skin") || c.is(".sca-fancybox-wrap"));) l = m(c[0]), c = t(c).parent();
                    0 === i || l || r.group.length > 1 && !o.canShrink && (a > 0 || n > 0 ? r.prev(a > 0 ? "down" : "left") : (a < 0 || n < 0) && r.next(a < 0 ? "up" : "right"), e.preventDefault())
                }))
            },
            trigger: function(e, o) {
                var i, n = o || r.coming || r.current;
                if (n) {
                    if (t.isFunction(n[e]) && (i = n[e].apply(n, Array.prototype.slice.call(arguments, 1))), !1 === i) return !1;
                    n.helpers && t.each(n.helpers, function(o, i) {
                        i && r.helpers[o] && t.isFunction(r.helpers[o][e]) && r.helpers[o][e](t.extend(!0, {}, r.helpers[o].defaults, i), n)
                    }), s.trigger(e)
                }
            },
            isImage: function(e) {
                return p(e) && e.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
            },
            isSWF: function(e) {
                return p(e) && e.match(/\.(swf)((\?|#).*)?$/i)
            },
            _start: function(e) {
                var o, i, n, a, s, c = {};
                if (e = u(e), !(o = r.group[e] || null)) return !1;
                if (c = t.extend(!0, {}, r.opts, o), a = c.margin, s = c.padding, "number" === t.type(a) && (c.margin = [a, a, a, a]), "number" === t.type(s) && (c.padding = [s, s, s, s]), c.modal && t.extend(!0, c, {
                        closeBtn: !1,
                        closeClick: !1,
                        nextClick: !1,
                        arrows: !1,
                        mouseWheel: !1,
                        keys: null,
                        helpers: {
                            overlay: {
                                closeClick: !1
                            }
                        }
                    }), c.autoSize && (c.autoWidth = c.autoHeight = !0), "auto" === c.width && (c.autoWidth = !0), "auto" === c.height && (c.autoHeight = !0), c.group = r.group, c.index = e, r.coming = c, !1 !== r.trigger("beforeLoad")) {
                    if (n = c.type, i = c.href, !n) return r.coming = null, !(!r.current || !r.router || "jumpto" === r.router) && (r.current.index = e, r[r.router](r.direction));
                    if (r.isActive = !0, "image" !== n && "swf" !== n || (c.autoHeight = c.autoWidth = !1, c.scrolling = "visible"), "image" === n && (c.aspectRatio = !0), "iframe" === n && d && (c.scrolling = "scroll"), c.wrap = t(c.tpl.wrap).addClass("sca-fancybox-" + (d ? "mobile" : "desktop") + " sca-fancybox-type-" + n + " sca-fancybox-tmp " + c.wrapCSS).appendTo(c.parent || "body"), t.extend(c, {
                            skin: t(".sca-fancybox-skin", c.wrap),
                            outer: t(".sca-fancybox-outer", c.wrap),
                            inner: t(".sca-fancybox-inner", c.wrap)
                        }), t.each(["Top", "Right", "Bottom", "Left"], function(e, o) {
                            c.skin.css("padding" + o, w(c.padding[e]))
                        }), r.trigger("onReady"), "inline" === n || "html" === n) {
                        if (!c.content || !c.content.length) return r._error("content")
                    } else if (!i) return r._error("href");
                    "image" === n ? r._loadImage() : "ajax" === n ? r._loadAjax() : "iframe" === n ? r._loadIframe() : r._afterLoad()
                } else r.coming = null
            },
            _error: function(e) {
                t.extend(r.coming, {
                    type: "html",
                    autoWidth: !0,
                    autoHeight: !0,
                    minWidth: 0,
                    minHeight: 0,
                    scrolling: "no",
                    hasError: e,
                    content: r.coming.tpl.error
                }), r._afterLoad()
            },
            _loadImage: function() {
                var e = r.imgPreload = new Image;
                e.onload = function() {
                    this.onload = this.onerror = null, r.coming.width = this.width / r.opts.pixelRatio, r.coming.height = this.height / r.opts.pixelRatio, r._afterLoad()
                }, e.onerror = function() {
                    this.onload = this.onerror = null, r._error("image")
                }, e.src = r.coming.href, !0 !== e.complete && r.showLoading()
            },
            _loadAjax: function() {
                var e = r.coming;
                r.showLoading(), r.ajaxLoad = t.ajax(t.extend({}, e.ajax, {
                    url: e.href,
                    error: function(e, o) {
                        r.coming && "abort" !== o ? r._error("ajax", e) : r.hideLoading()
                    },
                    success: function(o, t) {
                        "success" === t && (e.content = o, r._afterLoad())
                    }
                }))
            },
            _loadIframe: function() {
                var e = r.coming,
                    o = t(e.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", d ? "auto" : e.iframe.scrolling).attr("src", e.href);
                t(e.wrap).bind("onReset", function() {
                    try {
                        t(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
                    } catch (e) {}
                }), e.iframe.preload && (r.showLoading(), o.one("load", function() {
                    t(this).data("ready", 1), d || t(this).bind("load.fb", r.update), t(this).parents(".sca-fancybox-wrap").width("100%").removeClass("sca-fancybox-tmp").show(), r._afterLoad()
                })), e.content = o.appendTo(e.inner), e.iframe.preload || r._afterLoad()
            },
            _preloadImages: function() {
                var e, o, t = r.group,
                    i = r.current,
                    n = t.length,
                    a = i.preload ? Math.min(i.preload, n - 1) : 0;
                for (o = 1; o <= a; o += 1) "image" === (e = t[(i.index + o) % n]).type && e.href && ((new Image).src = e.href)
            },
            _afterLoad: function() {
                var e, o, i, n, a, s, c = r.coming,
                    l = r.current,
                    d = "sca-fancybox-placeholder";
                if (r.hideLoading(), c && !1 !== r.isActive) {
                    if (!1 === r.trigger("afterLoad", c, l)) return c.wrap.stop(!0).trigger("onReset").remove(), void(r.coming = null);
                    switch (l && (r.trigger("beforeChange", l), l.wrap.stop(!0).removeClass("sca-fancybox-opened").find(".sca-fancybox-item, .sca-fancybox-nav").remove()), r.unbindEvents(), e = c, o = c.content, i = c.type, n = c.scrolling, t.extend(r, {
                        wrap: e.wrap,
                        skin: e.skin,
                        outer: e.outer,
                        inner: e.inner,
                        current: e,
                        previous: l
                    }), a = e.href, i) {
                        case "inline":
                        case "ajax":
                        case "html":
                            e.selector ? o = t("<div>").html(o).find(e.selector) : h(o) && (o.data(d) || o.data(d, t('<div class="' + d + '"></div>').insertAfter(o).hide()), o = o.show().detach(), e.wrap.bind("onReset", function() {
                                t(this).find(o).length && o.hide().replaceAll(o.data(d)).data(d, !1)
                            }));
                            break;
                        case "image":
                            o = e.tpl.image.replace("{href}", a);
                            break;
                        case "swf":
                            o = '<object id="sca-fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + a + '"></param>', s = "", t.each(e.swf, function(e, t) {
                                o += '<param name="' + e + '" value="' + t + '"></param>', s += " " + e + '="' + t + '"'
                            }), o += '<embed src="' + a + '" type="application/x-shockwave-flash" width="100%" height="100%"' + s + "></embed></object>"
                    }
                    h(o) && o.parent().is(e.inner) || e.inner.append(o), r.trigger("beforeShow"), e.inner.css("overflow", "yes" === n ? "scroll" : "no" === n ? "hidden" : n), r._setDimension(), r.reposition(), r.isOpen = !1, r.coming = null, r.bindEvents(), r.isOpened ? l.prevMethod && r.transitions[l.prevMethod]() : t(".sca-fancybox-wrap").not(e.wrap).stop(!0).trigger("onReset").remove(), r.transitions[r.isOpened ? e.nextMethod : e.openMethod](), r._preloadImages()
                }
            },
            _setDimension: function() {
                var e, o, i, n, a, s, c, l, d, h, p, m, f, A, v, y = r.getViewport(),
                    z = 0,
                    x = !1,
                    b = !1,
                    C = r.wrap,
                    S = r.skin,
                    W = r.inner,
                    k = r.current,
                    E = k.width,
                    L = k.height,
                    I = k.minWidth,
                    T = k.minHeight,
                    H = k.maxWidth,
                    Q = k.maxHeight,
                    B = k.scrolling,
                    M = k.scrollOutside ? k.scrollbarWidth : 0,
                    R = k.margin,
                    q = u(R[1] + R[3]),
                    O = u(R[0] + R[2]);
                if (C.add(S).add(W).width("auto").height("auto").removeClass("sca-fancybox-tmp"), e = u(S.outerWidth(!0) - S.width()), o = u(S.outerHeight(!0) - S.height()), i = q + e, n = O + o, a = g(E) ? (y.w - i) * u(E) / 100 : E, s = g(L) ? (y.h - n) * u(L) / 100 : L, "iframe" === k.type) {
                    if (A = k.content, k.autoHeight && 1 === A.data("ready")) try {
                        A[0].contentWindow.document.location && (W.width(a).height(9999), v = A.contents().find("body"), M && v.css("overflow-x", "hidden"), s = v.outerHeight(!0))
                    } catch (e) {}
                } else(k.autoWidth || k.autoHeight) && (W.addClass("sca-fancybox-tmp"), k.autoWidth || W.width(a), k.autoHeight || W.height(s), k.autoWidth && (a = W.width()), k.autoHeight && (s = W.height()), W.removeClass("sca-fancybox-tmp"));
                if (E = u(a), L = u(s), d = a / s, I = u(g(I) ? u(I, "w") - i : I), H = u(g(H) ? u(H, "w") - i : H), T = u(g(T) ? u(T, "h") - n : T), Q = u(g(Q) ? u(Q, "h") - n : Q), c = H, l = Q, k.fitToView && (H = Math.min(y.w - i, H), Q = Math.min(y.h - n, Q)), m = y.w - q, f = y.h - O, k.aspectRatio ? (E > H && (L = u((E = H) / d)), L > Q && (E = u((L = Q) * d)), E < I && (L = u((E = I) / d)), L < T && (E = u((L = T) * d))) : (E = Math.max(I, Math.min(E, H)), k.autoHeight && "iframe" !== k.type && (W.width(E), L = W.height()), L = Math.max(T, Math.min(L, Q))), k.fitToView)
                    if (W.width(E).height(L), C.width(E + e), h = C.width(), p = C.height(), k.aspectRatio)
                        for (;
                            (h > m || p > f) && E > I && L > T && !(z++ > 19);) L = Math.max(T, Math.min(Q, L - 10)), (E = u(L * d)) < I && (L = u((E = I) / d)), E > H && (L = u((E = H) / d)), W.width(E).height(L), C.width(E + e), h = C.width(), p = C.height();
                    else E = Math.max(I, Math.min(E, E - (h - m))), L = Math.max(T, Math.min(L, L - (p - f)));
                M && "auto" === B && L < s && E + e + M < m && (E += M), W.width(E).height(L), C.width(E + e), h = C.width(), p = C.height(), x = (h > m || p > f) && E > I && L > T, b = k.aspectRatio ? E < c && L < l && E < a && L < s : (E < c || L < l) && (E < a || L < s), t.extend(k, {
                    dim: {
                        width: w(h),
                        height: w(p)
                    },
                    origWidth: a,
                    origHeight: s,
                    canShrink: x,
                    canExpand: b,
                    wPadding: e,
                    hPadding: o,
                    wrapSpace: p - S.outerHeight(!0),
                    skinSpace: S.height() - L
                }), !A && k.autoHeight && L > T && L < Q && !b && W.height("auto")
            },
            _getPosition: function(e) {
                var o = r.current,
                    t = r.getViewport(),
                    i = o.margin,
                    n = r.wrap.width() + i[1] + i[3],
                    a = r.wrap.height() + i[0] + i[2],
                    s = {
                        position: "absolute",
                        top: i[0],
                        left: i[3]
                    };
                return o.autoCenter && o.fixed && !e && a <= t.h && n <= t.w ? s.position = "fixed" : o.locked || (s.top += t.y, s.left += t.x), s.top = w(Math.max(s.top, s.top + (t.h - a) * o.topRatio)), s.left = w(Math.max(s.left, s.left + (t.w - n) * o.leftRatio)), s
            },
            _afterZoomIn: function() {
                var e = r.current;
                e && (r.isOpen = r.isOpened = !0, r.wrap.css("overflow", "visible").addClass("sca-fancybox-opened"), r.update(), (e.closeClick || e.nextClick && r.group.length > 1) && r.inner.css("cursor", "pointer").bind("click.fb", function(o) {
                    t(o.target).is("a") || t(o.target).parent().is("a") || (o.preventDefault(), r[e.closeClick ? "close" : "next"]())
                }), e.closeBtn && t(e.tpl.closeBtn).appendTo(r.skin).bind("click.fb", function(e) {
                    e.preventDefault(), r.close()
                }), e.arrows && r.group.length > 1 && ((e.loop || e.index > 0) && t(e.tpl.prev).appendTo(r.outer).bind("click.fb", r.prev), (e.loop || e.index < r.group.length - 1) && t(e.tpl.next).appendTo(r.outer).bind("click.fb", r.next)), r.trigger("afterShow"), e.loop || e.index !== e.group.length - 1 ? r.opts.autoPlay && !r.player.isActive && (r.opts.autoPlay = !1, r.play()) : r.play(!1))
            },
            _afterZoomOut: function(e) {
                e = e || r.current, t(".sca-fancybox-wrap").trigger("onReset").remove(), t.extend(r, {
                    group: {},
                    opts: {},
                    router: !1,
                    current: null,
                    isActive: !1,
                    isOpened: !1,
                    isOpen: !1,
                    isClosing: !1,
                    wrap: null,
                    skin: null,
                    outer: null,
                    inner: null
                }), r.trigger("afterClose", e)
            }
        }), r.transitions = {
            getOrigPosition: function() {
                var e = r.current,
                    o = e.element,
                    t = e.orig,
                    i = {},
                    n = 50,
                    a = 50,
                    s = e.hPadding,
                    c = e.wPadding,
                    l = r.getViewport();
                return !t && e.isDom && o.is(":visible") && ((t = o.find("img:first")).length || (t = o)), h(t) ? (i = t.offset(), t.is("img") && (n = t.outerWidth(), a = t.outerHeight())) : (i.top = l.y + (l.h - a) * e.topRatio, i.left = l.x + (l.w - n) * e.leftRatio), ("fixed" === r.wrap.css("position") || e.locked) && (i.top -= l.y, i.left -= l.x), i = {
                    top: w(i.top - s * e.topRatio),
                    left: w(i.left - c * e.leftRatio),
                    width: w(n + c),
                    height: w(a + s)
                }
            },
            step: function(e, o) {
                var t, i, n = o.prop,
                    a = r.current,
                    s = a.wrapSpace,
                    c = a.skinSpace;
                "width" !== n && "height" !== n || (t = o.end === o.start ? 1 : (e - o.start) / (o.end - o.start), r.isClosing && (t = 1 - t), i = e - ("width" === n ? a.wPadding : a.hPadding), r.skin[n](u("width" === n ? i : i - s * t)), r.inner[n](u("width" === n ? i : i - s * t - c * t)))
            },
            zoomIn: function() {
                var e = r.current,
                    o = e.pos,
                    i = e.openEffect,
                    n = "elastic" === i,
                    a = t.extend({
                        opacity: 1
                    }, o);
                delete a.position, n ? (o = this.getOrigPosition(), e.openOpacity && (o.opacity = .1)) : "fade" === i && (o.opacity = .1), r.wrap.css(o).animate(a, {
                    duration: "none" === i ? 0 : e.openSpeed,
                    easing: e.openEasing,
                    step: n ? this.step : null,
                    complete: r._afterZoomIn
                })
            },
            zoomOut: function() {
                var e = r.current,
                    o = e.closeEffect,
                    t = "elastic" === o,
                    i = {
                        opacity: .1
                    };
                t && (i = this.getOrigPosition(), e.closeOpacity && (i.opacity = .1)), r.wrap.animate(i, {
                    duration: "none" === o ? 0 : e.closeSpeed,
                    easing: e.closeEasing,
                    step: t ? this.step : null,
                    complete: r._afterZoomOut
                })
            },
            changeIn: function() {
                var e, o = r.current,
                    t = o.nextEffect,
                    i = o.pos,
                    n = {
                        opacity: 1
                    },
                    a = r.direction;
                i.opacity = .1, "elastic" === t && (e = "down" === a || "up" === a ? "top" : "left", "down" === a || "right" === a ? (i[e] = w(u(i[e]) - 200), n[e] = "+=200px") : (i[e] = w(u(i[e]) + 200), n[e] = "-=200px")), "none" === t ? r._afterZoomIn() : r.wrap.css(i).animate(n, {
                    duration: o.nextSpeed,
                    easing: o.nextEasing,
                    complete: r._afterZoomIn
                })
            },
            changeOut: function() {
                var e = r.previous,
                    o = e.prevEffect,
                    i = {
                        opacity: .1
                    },
                    n = r.direction;
                "elastic" === o && (i["down" === n || "up" === n ? "top" : "left"] = ("up" === n || "left" === n ? "-" : "+") + "=200px"), e.wrap.animate(i, {
                    duration: "none" === o ? 0 : e.prevSpeed,
                    easing: e.prevEasing,
                    complete: function() {
                        t(this).trigger("onReset").remove()
                    }
                })
            }
        }, r.helpers.overlay = {
            defaults: {
                closeClick: !0,
                speedOut: 200,
                showEarly: !0,
                css: {},
                locked: !d,
                fixed: !0
            },
            overlay: null,
            fixed: !1,
            el: t("html"),
            create: function(e) {
                e = t.extend({}, this.defaults, e), this.overlay && this.close(), this.overlay = t('<div class="sca-fancybox-overlay"></div>').appendTo(r.coming ? r.coming.parent : e.parent), this.fixed = !1, e.fixed && r.defaults.fixed && (this.overlay.addClass("sca-fancybox-overlay-fixed"), this.fixed = !0)
            },
            open: function(e) {
                var o = this;
                e = t.extend({}, this.defaults, e), this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(e), this.fixed || (a.bind("resize.overlay", t.proxy(this.update, this)), this.update()), e.closeClick && this.overlay.bind("click.overlay", function(e) {
                    if (t(e.target).hasClass("sca-fancybox-overlay")) return r.isActive ? r.close() : o.close(), !1
                }), this.overlay.css(e.css).show()
            },
            close: function() {
                var e, o;
                a.unbind("resize.overlay"), this.el.hasClass("sca-fancybox-lock") && (t(".sca-fancybox-margin").removeClass("sca-fancybox-margin"), e = a.scrollTop(), o = a.scrollLeft(), this.el.removeClass("sca-fancybox-lock"), a.scrollTop(e).scrollLeft(o)), t(".sca-fancybox-overlay").remove().hide(), t.extend(this, {
                    overlay: null,
                    fixed: !1
                })
            },
            update: function() {
                var e, t = "100%";
                this.overlay.width(t).height("100%"), c ? (e = Math.max(o.documentElement.offsetWidth, o.body.offsetWidth), s.width() > e && (t = s.width())) : s.width() > a.width() && (t = s.width()), this.overlay.width(t).height(s.height())
            },
            onReady: function(e, o) {
                var i = this.overlay;
                t(".sca-fancybox-overlay").stop(!0, !0), i || this.create(e), e.locked && this.fixed && o.fixed && (i || (this.margin = s.height() > a.height() && t("html").css("margin-right").replace("px", "")), o.locked = this.overlay.append(o.wrap), o.fixed = !1), !0 === e.showEarly && this.beforeShow.apply(this, arguments)
            },
            beforeShow: function(e, o) {
                var i, n;
                o.locked && (!1 !== this.margin && (t("*").filter(function() {
                    return "fixed" === t(this).css("position") && !t(this).hasClass("sca-fancybox-overlay") && !t(this).hasClass("sca-fancybox-wrap")
                }).addClass("sca-fancybox-margin"), this.el.addClass("sca-fancybox-margin")), i = a.scrollTop(), n = a.scrollLeft(), this.el.addClass("sca-fancybox-lock"), a.scrollTop(i).scrollLeft(n)), this.open(e)
            },
            onUpdate: function() {
                this.fixed || this.update()
            },
            afterClose: function(e) {
                this.overlay && !r.coming && this.overlay.fadeOut(e.speedOut, t.proxy(this.close, this))
            }
        }, r.helpers.title = {
            defaults: {
                type: "float",
                position: "bottom"
            },
            beforeShow: function(e) {
                var o, i, n = r.current,
                    a = n.title,
                    s = e.type;
                if (t.isFunction(a) && (a = a.call(n.element, n)), p(a) && "" !== t.trim(a)) {
                    switch (o = t('<div class="sca-fancybox-title sca-fancybox-title-' + s + '-wrap">' + a + "</div>"), s) {
                        case "inside":
                            i = r.skin;
                            break;
                        case "outside":
                            i = r.wrap;
                            break;
                        case "over":
                            i = r.inner;
                            break;
                        default:
                            i = r.skin, o.appendTo("body"), c && o.width(o.width()), o.wrapInner('<span class="child"></span>'), r.current.margin[2] += Math.abs(u(o.css("margin-bottom")))
                    }
                    o["top" === e.position ? "prependTo" : "appendTo"](i)
                }
            }
        }, t.fn.scafancybox = function(e) {
            var o, i = t(this),
                n = this.selector || "",
                a = function(a) {
                    var s, c, l = t(this).blur(),
                        d = o;
                    a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || l.is(".sca-fancybox-wrap") || (s = e.groupAttr || "data-sca-fancybox-group", (c = l.attr(s)) || (s = "rel", c = l.get(0)[s]), c && "" !== c && "nofollow" !== c && (d = (l = (l = n.length ? t(n) : i).filter("[" + s + '="' + c + '"]')).index(this)), e.index = d, !1 !== r.open(l, e) && a.preventDefault())
                };
            return e = e || {}, o = e.index || 0, n && !1 !== e.live ? s.undelegate(n, "click.fb-start").delegate(n + ":not('.sca-fancybox-item, .sca-fancybox-nav')", "click.fb-start", a) : i.unbind("click.fb-start").bind("click.fb-start", a), this.filter("[data-sca-fancybox-start=1]").trigger("click"), this
        }, t.fn.scashowLoading = function() {
            r.showLoading()
        }, t.fn.scahideLoading = function() {
            r.hideLoading()
        }, s.ready(function() {
            var o, a;
            t.scrollbarWidth === i && (t.scrollbarWidth = function() {
                var e = t('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                    o = e.children(),
                    i = o.innerWidth() - o.height(99).innerWidth();
                return e.remove(), i
            }), t.support.fixedPosition === i && (t.support.fixedPosition = function() {
                var e = t('<div style="position:fixed;top:20px;"></div>').appendTo("body"),
                    o = 20 === e[0].offsetTop || 15 === e[0].offsetTop;
                return e.remove(), o
            }()), t.extend(r.defaults, {
                scrollbarWidth: t.scrollbarWidth(),
                fixed: t.support.fixedPosition,
                parent: t("body")
            }), o = t(e).width(), n.addClass("sca-fancybox-lock-test"), a = t(e).width(), n.removeClass("sca-fancybox-lock-test"), t("<style type='text/css'>.sca-fancybox-margin{margin-right:" + (a - o) + "px;}</style>").appendTo("head")
        })
    }

    function preloadQV(e, o) {
        var t = o.attr("handle");
        return e.ajax({
            dataType: "json",
            url: "/products/" + t + ".js"
        }).done(function(e) {
            SCAShopify.preload(e.images, "large"), SCAShopify.preload(e.images)
        })
    }

    function findQVContainer(e, o) {
        return e('a[href*="/products/"]', o.parent()).has('img[src*="/products/"] , img[src*="/no-image"]').length > 1 || o.parent().width() - o.width() > 50 ? o : findQVContainer(e, o.parent())
    }

    function loadData(e, o) {
        collection_handle = o.collection_handle, "yes" == o.autoconfig && initQuickViewContent(e), scaqvFancybox(window, document, e, void 0), scaqvImageZoom(e, window, document, void 0);
        var t = o.jsondata;
        return moneyFormat = o.moneyFormat, console.log("collection_handle : " + collection_handle), noimage = o.noimage, console.log("no image : " + noimage), add_to_cart_text = e("#sca-qv-showqv .sca-qv-cartbtn").val(), e("#sca-qv-unavailable").length && (unavailable_text = e("#sca-qv-unavailable").text()), o.overlay_lock && (overlay_lock = o.overlay_lock), settings = e.parseJSON(SCABase64.decode(t)), console.log("Disable QV : " + settings.qv_disable), "on" != settings.qv_disable && (SCASettings.loadSettings(e, settings), !0)
    }

    function createCartForm(e, o, t) {
        var i = e("#sca-qv-add-item-form", t);
        if (0 != i.length) {
            var n = e("#sca-qv-variant-options", e(".sca-qv-product-options", i));
            n.empty(), n.append('<div > <select id="sca-qv-product-selected" name="id" class="sca-qv-hidden"> </select> </div>');
            var a = e("#sca-qv-product-selected", n);
            a.empty();
            var s = o.variants,
                r = !1;
            e.each(s, function(e, o) {
                var t = "";
                o.available && 0 == r && (r = !0, t = 'selected="selected"'), a.append('<option value="' + o.id + '" ' + t + ">" + o.title + " - " + SCAShopify.formatMoney(o.price, moneyFormat) + "</option>")
            }), e("#sca-qv-quantity", t).val("1"), e("#sca-qv-sold-out").addClass("sca-qv-hidden"), o.available ? (e(".sca-qv-cartbtn").removeClass("sca-qv-hidden"), e(".sca-qv-cartbtn").removeClass("disabled").removeAttr("disabled").val(add_to_cart_text)) : (e(".sca-qv-cartbtn").removeClass("sca-qv-hidden"), e(".sca-qv-cartbtn").val(e("#sca-qv-sold-out").text()).addClass("disabled").attr("disabled", "disabled")), formatVariantOption(e, o)
        }
    }

    function showIfProductAdd(e, o) {
        -1 != e.inArray(o, list_cart_variants) && (e("#sca-qv-addcart-msg").html(product_in_cart), e("#sca-qv-addcart-msg").fadeIn(1e3))
    }

    function convert_currency() {
        try {
            "undefined" != typeof Currency && void 0 !== Currency.convertAll && Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency)
        } catch (e) {
            console.log(e)
        }
    }

    function formatVariantOption(e, o) {
        var t = e("#sca-qv-showqv");
        try {
            new Shopify.OptionSelectors("sca-qv-product-selected", {
                product: o,
                onVariantSelected: function(o, t) {
                    e("#sca-qv-addcart-msg").hide();
                    var i = "";
                    void 0 != settings.price_color && null != settings.price_color && (i = settings.price_color);
                    var n = e("#sca-qv-showqv");
                    o ? (o.available ? (showIfProductAdd(e, o.id), e(".sca-qv-cartbtn").removeClass("disabled").removeAttr("disabled").val(add_to_cart_text)) : e(".sca-qv-cartbtn").val(e("#sca-qv-sold-out").text()).addClass("disabled").attr("disabled", "disabled"), o.compare_at_price > o.price ? e(".sca-qv-price-container", n).html('<span class="sca-qv-product-price" style="color:' + i + ' !important;">' + SCAShopify.formatMoney(o.price, moneyFormat) + '&nbsp;<del class="sca-qv-product-compare-price">' + SCAShopify.formatMoney(o.compare_at_price, moneyFormat) + "</del></span>") : e(".sca-qv-price-container", n).html('<span class="sca-qv-product-price"  style="color:' + i + ' !important;">' + SCAShopify.formatMoney(o.price, moneyFormat) + "</span>")) : e(".sca-qv-cartbtn").val(unavailable_text).addClass("disabled").attr("disabled", "disabled")
                }
            })
        } catch (e) {
            console.log(e)
        }
        1 == o.options.length && "Title" != o.options[0] && 0 == e(".selector-wrapper:eq(0) label", t).length && e(".selector-wrapper:eq(0)", t).prepend("<label>" + o.options[0] + "</label>");
        var i = !1,
            n = o.variants;
        e.each(n, function(n, a) {
            if (a.available && 0 == i) {
                i = !0;
                var s = o.options;
                e.each(s, function(o, i) {
                    e(".single-option-selector:eq(" + o + ")", t).val(a.options[o]).trigger("change")
                })
            }
        }), e("#sca-qv-variant-options").removeClass("sca-qv-hidden"), 1 == o.variants.length && o.variants[0].title.indexOf("Default") > -1 && e("#sca-qv-variant-options").addClass("sca-qv-hidden")
    }

    function truncate(e, o) {
        var t = (o = (o = (o = e("<div/>").html(o).text()).replace(/\r?\n/g, "")).replace(/<!--\n?.*\n?-->/, "")).split(" ");
        return o = t.length > 30 ? t.splice(0, 30).join(" ") + "..." : o
    }

    function truncateNode(e) {
        if (0 == e.children().length && target > 0) {
            var o = e.text().trim().split(/\s+/),
                t = o.length - target;
            t > 0 ? target = 0 : e.text().trim().length > 0 && (target -= o.length);
            var i = t >= 0 ? o.splice(0, t).join(" ") + "..." : "";
            i.length > 0 ? e.text(i) : e.remove()
        } else if (e.children().length > 0 && target > 0) {
            for (var n = e.children().length - 1; n > -1; --n) truncateNode(e.children("*:eq(" + n + ")"));
            truncateNode(e)
        }
    }

    function createDesc(e, o, t) {
        settings.des_num || (settings.des_num = 30);
        var i = e("#sca-qv-des");
        i.off(), i.empty();
        var n = e("<div/>").html(o.description);
        target = n.text().split(/\s+/).length - settings.des_num, n.text().split(/\s+/).length > settings.des_num && truncateNode(n, n.text().split(/\s+/).length - settings.des_num), 0 == settings.des_num ? i.html("") : i.html(n.html()), i.append('<div class="clear-both"></div')
    }

    function createDetail(e, o, t, i) {
        var n = e("#sca-qv-detail", t);
        null != collection_handle ? n.attr("href", i.replace(".js", "")) : n.attr("href", "/products/" + o.handle)
    }

    function createPrice(e, o, t) {
        var i = e("#sca-qv-price-container", t);
        i.empty(), o.compare_at_price > o.price ? (e("#sca-qv-sale").removeClass("sca-qv-hidden"), i.append('<span class="sca-qv-product-price ">' + SCAShopify.formatMoney(o.price, moneyFormat) + '&nbsp;<del class="sca-qv-product-compare-price">' + SCAShopify.formatMoney(o.compare_at_price, moneyFormat) + "</del>  </span>")) : i.append('<span class="sca-qv-product-price ">' + SCAShopify.formatMoney(o.price, moneyFormat) + "</span>")
    }

    function createTitle(e, o, t) {
        var i = e("#sca-qv-title", t);
        i.empty(), i.append("<strong>" + o.title + "</strong>")
    }

    function createGallery(e, o, t) {
        var i = e("#sca-qv-galleryid", t);
        i.empty();
        var n = o.images,
            a = (parseInt(settings.img_main_width, 10) - 8) / 4;
        n.length > 1 && (cratezoomgalery(e, i, o.featured_image, a), e.each(n, function(o, t) {
            0 < o && o < 4 && cratezoomgalery(e, i, t, a)
        }))
    }

    function cratezoomgalery(e, o, t, i) {
        var n = "max-width:" + i + "px;max-height:" + i + "px;  ",
            a = '<a href="#" data-image="' + SCAShopify.resizeImage(t, "large") + '" data-zoom-image="' + SCAShopify.resizeImage(t, "original") + '"  class="sca-qv-gallery-a" > <img src="' + SCAShopify.resizeImage(t, "large") + '" class="sca-qv-gallery-img" style="' + n + '"/> </a>';
        o.append(a)
    }

    function createZoomContainer(e, o, t) {
        var i = e("#sca-qv-zoomcontainer", t);
        i.empty();
        var n = noimage;
        null != o.featured_image && (n = o.featured_image), i.append('<img  id="sca-qv-zoomImg" style="max-width:' + settings.img_main_width + ";max-height:" + settings.img_main_width + '" src="' + SCAShopify.resizeImage(n, "large") + '" data-zoom-image="' + SCAShopify.resizeImage(n, "original") + '" alt=""  >')
    }

    function cleanTemplate(e, o) {
        e("#sca-qv-zoomcontainer", o).empty(), e("#sca-qv-galleryid", o).empty(), e("#sca-qv-title", o).empty(), e("#sca-qv-price-container", o).empty(), e("#sca-qv-des", o).empty();
        var t = e("#sca-qv-variant-options", e(".sca-qv-product-options", e("#sca-qv-add-item-form", o)));
        t.empty(), e("#sca-qv-product-selected", t).empty()
    }

    function preloadQV(e, o) {
        var t, i = e(".sca-qv-button");
        if (o > -1 && i.length > o) {
            t = i.eq(o), console.log(t);
            var n = t.attr("handle");
            e.ajax({
                dataType: "json",
                url: "/products/" + n + ".js"
            }).done(function(e) {
                SCAShopify.preload(e.images, "large"), SCAShopify.preload(e.images)
            })
        }
    }

    function preloadNearItem(e, o) {
        var t = e(".sca-qv-button").index(o);
        preloadQV(e, t - 1), preloadQV(e, t + 1)
    }

    function freegifts_filter(e, o) {
        var t = [];
        return e.each(o.variants, function(o, i) {
            var n = !1;
            e.each(i.options, function(e, o) {
                if (o.length > 6 && "% off)" == o.substring(o.length - 6, o.length)) return n = !0, !1;
                if (o.length > 6 && "% Off)" == o.substring(o.length - 6, o.length)) return n = !0, !1;
                if (o.length > 11 && "(Freegifts)" == o.substring(o.length - 11, o.length)) return n = !0, !1;
                try {
                    var t = /\(BK \d+\)/g;
                    if (o.match(t)) return n = !0, !1
                } catch (e) {}
            }), n || t.push(i)
        }), o.variants = t, o
    }

    function buyx_product_json(e, o) {
        for (var t = [], i = -1, n = 0, a = o.options.length; n < a; n++)
            if ("BuyXDiscount" == o.options[n]) {
                i = n + 1;
                break
            }
        if (-1 == i) return o;
        o.options.length > 1 ? o.options.splice(i - 1, 1) : o.options[0] = "Title", i = "option" + i, o.available = !1;
        for (var s = 0, r = o.variants.length; s < r; s++) "Default" == o.variants[s][i] && (o.variants[s][i] = "", t.push(o.variants[s]), o.available = o.available || o.variants[s].available);
        return o.variants = t, o
    }
    "undefined" == typeof SCAShopify && (SCAShopify = {}), SCAShopify.preload = function(e, o) {
        for (var t = 0; t < e.length; t++) {
            var i = e[t];
            SCAShopify.loadImage(SCAShopify.getSizedImageUrl(i, o))
        }
    }, SCAShopify.loadImage = function(e) {
        (new Image).src = e
    }, SCAShopify.getSizedImageUrl = function(e, o) {
        if (null == o) return e;
        if ("master" == o) return SCAShopify.removeProtocol(e);
        var t = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != t) {
            var i = e.split(t[0]),
                n = t[0];
            return SCAShopify.removeProtocol(i[0] + "_" + o + n)
        }
        return null
    }, SCAShopify.removeProtocol = function(e) {
        return e.replace(/http(s)?:/, "")
    };
    for (var method, noop = function() {}, methods = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "table", "time", "timeEnd", "timeStamp", "trace", "warn"], length = methods.length, console = window.console = window.console || {}; length--;) method = methods[length], console[method] || (console[method] = noop);
    SCAShopify.money_format = "${{amount}}", SCAShopify.formatMoney = function(e, o) {
        function t(e, o) {
            return void 0 === e ? o : e
        }

        function i(e, o, i, n) {
            if (o = t(o, 2), i = t(i, ","), n = t(n, "."), isNaN(e) || null == e) return 0;
            var a = (e = (e / 100).toFixed(o)).split(".");
            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "")
        }
        if ("undefined" != typeof Shopify && void 0 !== Shopify.formatMoney) return Shopify.formatMoney(e, o);
        "string" == typeof e && (e = e.replace(".", ""));
        var n = "",
            a = /\{\{\s*(\w+)\s*\}\}/,
            s = o || this.money_format;
        switch (s.match(a)[1]) {
            case "amount":
                n = i(e, 2);
                break;
            case "amount_no_decimals":
                n = i(e, 0);
                break;
            case "amount_with_comma_separator":
                n = i(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = i(e, 0, ".", ",")
        }
        return s.replace(a, n)
    }, SCAShopify.resizeImage = function(e, o) {
        try {
            if ("original" == o) return e;
            var t = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
            return t[1] + "_" + o + "." + t[2]
        } catch (o) {
            return e
        }
    };
    var loadjscssfile = function(e, o) {
            if ("js" == o)(t = document.createElement("script")).setAttribute("type", "text/javascript"), t.setAttribute("src", e);
            else if ("css" == o) {
                var t = document.createElement("link");
                t.setAttribute("rel", "stylesheet"), t.setAttribute("type", "text/css"), t.setAttribute("href", e)
            }
            void 0 !== t && document.getElementsByTagName("head")[0].appendChild(t)
        },
        list_cart_variants = [],
        SCASettings = {
            loadSettings: function(e, o) {
                e("#sca-qv-cartform .sca-qv-product-options").append('<div id="sca-qv-addcart-msg" class="sca-qv-addcart-msg" style="position: absolute !important; margin-top:15px"></div>'), void 0 != o.cart_notify_add_format && void 0 != o.cart_notify_in_format && (product_in_cart = o.cart_notify_add_format.replace("*", '<a href="/cart"  class="sca-qv-msg-cart-link">').replace("%", "</a>"), product_added = o.cart_notify_in_format.replace("*", '<a href="/cart"  class="sca-qv-msg-cart-link">').replace("%", "</a>"));
                var t = ".fancyox-view-detail .zoomWrapper img {  max-width:" + o.img_main_width + " !important ; max-height:" + o.img_main_width + " !important ;   }",
                    i = document.head || document.getElementsByTagName("head")[0],
                    n = document.createElement("style");
                if (void 0 != o.cart_color && (t += " a.sca-qv-cartbtn-config, input.sca-qv-cartbtn-config {background:none repeat scroll 0 0 " + o.cart_color + " !important;}", e(".sca-qv-cartbtn").addClass("sca-qv-cartbtn-config")), void 0 != o.sale_icon_color && (t += a = "  .sca-qv-sale-settings {background-color:" + o.sale_icon_color + " !important;}", e("#sca-qv-sale").addClass("sca-qv-sale-settings")), void 0 != o.link_color && (t += a = "  #sca-qv-right a {color:" + o.link_color + ";}"), void 0 != o.title_color) {
                    var a = "  #sca-qv-title strong {color:" + o.title_color + ";}";
                    t += a
                }
                n.type = "text/css", n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t)), i.appendChild(n);
                var s = e(".sca-qv-button");
                s.parent().parent().addClass("sca-qv-image"), s.text(o.bnt_text), isMoblieBrowser() || s.hover(function() {
                    e(this).css({
                        color: o.bnt_text_hover,
                        background: o.bnt_color_hover
                    })
                }, function() {
                    e(this).css({
                        color: o.bnt_text_color,
                        "background-color": o.bnt_color
                    })
                }), s.css({
                    "font-family": "auto" != o.bnt_text_font ? o.bnt_text_font : "",
                    "font-size": o.bnt_text_fontsize,
                    top: "top" == o.bnt_possition ? "20%" : "bottom" == o.bnt_possition ? "80%" : "5%0",
                    color: o.bnt_text_color,
                    "background-color": o.bnt_color
                }), isMoblieBrowser() || e(".sca-qv-image").hover(function() {
                    e(".sca-qv-button", this).parent().show()
                }, function() {
                    e(".sca-qv-button", this).parent().hide()
                })
            }
        },
        SCABase64 = {
            _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            encode: function(e) {
                var o, t, i, n, a, s, r, c = "",
                    l = 0;
                for (e = SCABase64._utf8_encode(e); l < e.length;) n = (o = e.charCodeAt(l++)) >> 2, a = (3 & o) << 4 | (t = e.charCodeAt(l++)) >> 4, s = (15 & t) << 2 | (i = e.charCodeAt(l++)) >> 6, r = 63 & i, isNaN(t) ? s = r = 64 : isNaN(i) && (r = 64), c = c + this._keyStr.charAt(n) + this._keyStr.charAt(a) + this._keyStr.charAt(s) + this._keyStr.charAt(r);
                return c
            },
            decode: function(e) {
                var o, t, i, n, a, s, r = "",
                    c = 0;
                for (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); c < e.length;) o = this._keyStr.indexOf(e.charAt(c++)) << 2 | (n = this._keyStr.indexOf(e.charAt(c++))) >> 4, t = (15 & n) << 4 | (a = this._keyStr.indexOf(e.charAt(c++))) >> 2, i = (3 & a) << 6 | (s = this._keyStr.indexOf(e.charAt(c++))), r += String.fromCharCode(o), 64 != a && (r += String.fromCharCode(t)), 64 != s && (r += String.fromCharCode(i));
                return r = SCABase64._utf8_decode(r)
            },
            _utf8_encode: function(e) {
                e = e.replace(/\r\n/g, "\n");
                for (var o = "", t = 0; t < e.length; t++) {
                    var i = e.charCodeAt(t);
                    i < 128 ? o += String.fromCharCode(i) : i > 127 && i < 2048 ? (o += String.fromCharCode(i >> 6 | 192), o += String.fromCharCode(63 & i | 128)) : (o += String.fromCharCode(i >> 12 | 224), o += String.fromCharCode(i >> 6 & 63 | 128), o += String.fromCharCode(63 & i | 128))
                }
                return o
            },
            _utf8_decode: function(e) {
                for (var o = "", t = 0, i = c1 = c2 = 0; t < e.length;)(i = e.charCodeAt(t)) < 128 ? (o += String.fromCharCode(i), t++) : i > 191 && i < 224 ? (c2 = e.charCodeAt(t + 1), o += String.fromCharCode((31 & i) << 6 | 63 & c2), t += 2) : (c2 = e.charCodeAt(t + 1), c3 = e.charCodeAt(t + 2), o += String.fromCharCode((15 & i) << 12 | (63 & c2) << 6 | 63 & c3), t += 3);
                return o
            }
        },
        settings, moneyFormat, add_to_cart_text, unavailable_text = "Unavailable",
        noimage, overlay_lock = !1,
        loadScript = function(e, o) {
            var t = document.createElement("script");
            t.type = "text/javascript", t.readyState ? t.onreadystatechange = function() {
                "loaded" != t.readyState && "complete" != t.readyState || (t.onreadystatechange = null, o())
            } : t.onload = function() {
                o()
            }, t.src = e, document.getElementsByTagName("head")[0].appendChild(t)
        },
        initQuickViewContent = function(e) {
            if (!isMoblieBrowser())
                for (var o = e('a[href*="/products/"]:not([href*=".jp"]):not(form a[href*="/products/"]):not(.related-products a[href*="/products/"]):not(.not-sca-qv a[href*="/products/"]):not([href*=".JP"]):not([href*=".png"]):not([href*=".PNG"])').has('img[src*="/products/"]:not([class*="not-sca-qv"]), img[src*="/no-image"],img[data-srcset*="/products/"]:not([class*="not-sca-qv"])'), t = 0; t < o.length; ++t) {
                    var i = o.eq(t),
                        n = i.attr("href").split("/"),
                        a = n[n.length - 1].split("?")[0];
                    null != collection_handle && (a = i.attr("href").split("?")[0] + ".js");
                    var s = i.parent();
                    try {
                        s = findQVContainer(e, i.parent())
                    } catch (e) {
                        console.log("error when get product container "), console.log(e)
                    }
                    void 0 != s && null != s || (s = i.parent()), 0 == e(".sca-qv-button", s).length && s.append('<div class="sca-qv-button-wrap" style="display: none !important;" ><a class="sca-qv-button"  href="#sca-qv-showqv" handle="?" ></a></div>'.replace("?", a))
                }
        },
        product_in_cart = 'This product in <a href="/cart"  class="sca-qv-msg-cart-link">cart</a> already.',
        product_added = 'Item added to cart! <a href="/cart"  class="sca-qv-msg-cart-link">View Cart</a>.',
        collection_handle;
    SCAShopify.initSettings = function(e) {
        loadProductFromCart(e = SCAShopify.jQuery);
        var o = !1;
        return e.ajax({
            dataType: "json",
            url: "/index?view=sca.quickviewpro",
            contentType: "application/json; charset=utf-8",
            success: function(t) {
                o = loadData(e, t), onAddCartClicked(e), o && displayQuickView(e)
            },
            error: function() {
                console.log("cant  load metadata and try with html");
                var t = e("#scaqv-metadata");
                if (t.length < 1) return !1;
                var i = {};
                i.jsondata = t.attr("jsondata"), i.moneyFormat = t.attr("moneyFormat"), i.noimage = t.attr("noimage"), i.autoconfig = t.attr("autoconfig"), o = loadData(e, i), onAddCartClicked(e), o && displayQuickView(e)
            }
        }), o
    };
    var target, getProductJson = function(e, o, t) {
            var i;
            return i = null != collection_handle ? o : "/products/" + o + ".js", e.ajax({
                type: "GET",
                dataType: "json",
                url: i,
                success: function(e) {
                    t(SCAShopify.jQuery, e)
                }
            }).responseText
        },
        callbackQV = function(e, o) {
            var t = [];
            e.each(o.options, function(e, o) {
                t[e] = o.name
            }), o.options = t;
            try {
                o = freegifts_filter(e, o), o = buyx_product_json(e, o)
            } catch (e) {
                console.log(e)
            }
            var i = e("#sca-qv-left");
            createZoomContainer(e, o, i), createGallery(e, o, i), SCAShopify.preload(o.images), SCAShopify.preload(o.images, "large");
            var n = e("#sca-qv-right");
            createTitle(e, o, n), createPrice(e, o, n), createDesc(e, o, n), createDetail(e, o, n, o.handle), createCartForm(e, o, n);
            try {
                "undefined" != typeof sca_default_callback_function && sca_default_callback_function(e, o)
            } catch (e) {
                console.log(e), console.log("custom quick view function error")
            }
            var a = new Image;
            a.onload = function() {
                var o = a.height,
                    t = 10,
                    i = setInterval(function() {
                        (a = new Image).src = e("#sca-qv-zoomImg").attr("src"), o = a.height, (0 == --t || o > 0) && (window.clearInterval(i), zoomAllProduct(e), e("#sca-qv-zoomcontainer").outerHeight() < e("#sca-qv-zoomImg").outerHeight() && e("#sca-qv-zoomcontainer").height(e("#sca-qv-zoomImg").outerHeight()), "auto" == settings.wd_width || "auto" == settings.wd_height ? e.scafancybox.scaupdate() : (e("#sca-qv-right").outerHeight() > e("#sca-qv-left").outerHeight() && e("#sca-qv-left").outerHeight(e("#sca-qv-right").outerHeight()), e.scafancybox.hideLoading()))
                    }, 300)
            }, a.onerror = function() {
                console.error("Cannot load image"), e.scafancybox.hideLoading()
            }, a.src = e("#sca-qv-zoomImg").attr("src"), e("#sca-qv-right").outerHeight() > e(".sca-fancybox-inner").outerHeight() && (e("#sca-qv-left").outerHeight(""), e("#sca-qv-left").height(""), e("#sca-qv-right").outerHeight(""), e("#sca-qv-right").height(""), e(".sca-fancybox-inner").css("overflow", "auto"));
            try {
                e("#sca-qv-showqv").hasClass("sca-bm") && (e(".sca-fancybox-outer").append('<div id="sca-brankmark" class="sca-brankmark" style=" position: absolute;bottom: -50px;left:45% ;  background: transparent !important;display:block !important; font-family:sans-serif;font-size:13px;text-align:center;box-sizing:border-box"><a  onclick="window.open(\'http://secomapp.com/?utm_channel=referral&utm_medium=quickview&utm_campaign=qvreferral\', \'_blank\')" href="http://secomapp.com/?utm_channel=referral&utm_medium=quickview&utm_campaign=qvreferral" style="color:white!important;">Powered by <span style="color:#006eff!important;text-decoration: underline;">Secomapp</span></a> </div>'), e("#sca-brankmark a").click(function(e) {
                    e.preventDefault()
                }))
            } catch (e) {}
        },
        displayQuickView = function(e) {
            if (!isMoblieBrowser()) {
                e = SCAShopify.jQuery;
                var o = !1,
                    t = 9999,
                    i = 9999,
                    n = parseInt(settings.wd_width, 10) || 720,
                    a = parseInt(settings.wd_height, 10) || 200;
                "auto" != settings.wd_width && "auto" != settings.wd_height || (o = !0, t = n), "auto" != settings.wd_height && (i = a), e(".sca-qv-button").scafancybox({
                    arrows: !1,
                    openEffect: "elastic",
                    scrolling: "no",
                    maxHeight: i,
                    maxWidth: t,
                    autoSize: o,
                    minHeight: a,
                    minWidth: n,
                    title: null,
                    helpers: {
                        overlay: {
                            locked: overlay_lock
                        }
                    },
                    beforeLoad: function() {
                        loadProductFromCart(e), cleanTemplate(e, e("#sca-qv-showqv")), e("#sca-qv-addcart-msg").hide(), e("#sca-qv-sale").addClass("sca-qv-hidden")
                    },
                    afterShow: function() {
                        var o = e(this.element);
                        o.scashowLoading();
                        var t = o.attr("handle");
                        if (void 0 != t) getProductJson(e, e.trim(t), callbackQV);
                        else if (e('span[class="sca-qv-handle"]', o.parent()).length > 0) {
                            t = e('span[class="sca-qv-handle"]', o.parent());
                            getProductJson(e, e.trim(t.html()), callbackQV)
                        } else t = e("span", o.parent()), e.parseJSON(e.trim(t.html()))
                    },
                    afterClose: function() {
                        e.scafancybox.hideLoading()
                    }
                })
            }
        },
        zoomAllProduct = function(e) {
            e("#sca-qv-zoomImg").elevateZoom({
                gallery: "sca-qv-galleryid",
                zoomWindowOffetx: 10,
                borderSize: 1,
                scrollZoom: !0,
                cursor: "pointer"
            })
        },
        onAddCartClicked = function($) {
            function updateCartcount(e) {
                var o = parseInt($('[name="quantity"]', e).val(), 10) || 1,
                    t = (parseInt($(settings.cartcount).text(), 10) || 0) + o;
                return $(settings.cartcount).text(t), $(settings.cartcount).show(), o
            }

            function updateCartTotal() {
                $.getJSON("/cart.js", function(e) {
                    $(settings.cart_total).html(SCAShopify.formatMoney(e.total_price, moneyFormat)), $(settings.cart_total).show()
                })
            }

            function updateCart(e, o) {
                console.log(o), $.ajax({
                    type: "get",
                    cache: !1,
                    async: !1,
                    url: o,
                    success: function(o) {
                        var t = $("<div/>").html(o);
                        $.each(e.split("|"), function(e, o) {
                            var i = $.trim(o),
                                n = $(i, t);
                            $(i).empty(), $(i).append(n.html())
                        })
                    },
                    error: function() {
                        console.log("add to cart error")
                    }
                })
            }

            function addItem(e, o) {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: o.serialize(),
                    success: scaonSuccess(o),
                    error: scaonError
                }).done(function(e) {
                    if (void 0 === Shopify.getCart) {
                        o = window.location.protocol + "//" + window.location.host + window.location.pathname;
                        updateCart(t = settings.cartcount + "|" + settings.cart_total, o)
                    } else try {
                        Shopify.getCart(function() {
                            var e = window.location.protocol + "//" + window.location.host + window.location.pathname;
                            updateCart(settings.cartcount + "|" + settings.cart_total, e)
                        })
                    } catch (e) {
                        var o = window.location.protocol + "//" + window.location.host + window.location.pathname,
                            t = settings.cartcount + "|" + settings.cart_total;
                        updateCart(t, o)
                    }
                })
            }
            $(".sca-qv-cartbtn").click(function(e) {
                var o = $("#sca-qv-add-item-form");
                if ($(this).attr("form-id") && "" != $(this).attr("form-id") && (o = $($(this).attr("form-id"))), "no" == settings.cart_go) {
                    var t = $(this);
                    $(t).prop("disabled", !0), e.preventDefault(), addItem("sca-qv-add-item-form", o)
                } else o.attr("action", "/cart/add"), o.submit()
            });
            var scaonSuccess = function(e) {
                    $("#sca-qv-addcart-msg").hide(), $("#sca-qv-addcart-msg").html(product_added), $("#sca-qv-addcart-msg").fadeIn(700, function() {
                        $(".sca-qv-cartbtn", e).removeAttr("disabled")
                    })
                },
                scaonError = function(XMLHttpRequest, textStatus) {
                    var data = eval("(" + XMLHttpRequest.responseText + ")");
                    data.message ? alert(data.message + "(" + data.status + "): " + data.description) : alert("Error : " + scafullMessagesFromErrors(data).join("; ") + "."), $(".sca-qv-cartbtn").removeAttr("disabled")
                },
                scafullMessagesFromErrors = function(e) {
                    var o = [];
                    return $.each(e, function(e, t) {
                        $.each(t, function(t, i) {
                            o.push(e + " " + i)
                        })
                    }), o
                }
        },
        $checkVersion = function(e, o) {
            try {
                var t = e.split("."),
                    i = o.split("."),
                    n = 1e8 * parseInt(t[0]) + 1e6 * parseInt(t[1]) + 1e4 * parseInt(t[2]),
                    a = 1e8 * parseInt(i[0]) + 1e6 * parseInt(i[1]) + 1e4 * parseInt(i[2]);
                return n > a ? 1 : n < a ? -1 : 0
            } catch (e) {
                console.log(e)
            }
            return 1
        };
    SCAShopify.loaded || (SCAShopify.loaded = !0, console.log("load jquery 1.11"), loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js", function() {
        jQuery191 = jQuery.noConflict(!0), SCAShopify.jQuery = jQuery191, jQuery191(document).ready(function() {
            if (!(jQuery191('script:contains("sca-qv-scripts-noconfig"):contains("asyncLoad")').length > 0)) return SCAShopify.loaded = !1, !1;
            loadScript("//cdnjs.cloudflare.com/ajax/libs/json2/20130526/json2.min.js", function() {});
            SCAShopify.initSettings(jQuery191)
        })
    }))
}();